export default {
  header: {
    product: "Sản phẩm",
    subproduct: [
      {
        name: "sản phẩm",
        item: [
          {
            name: "",
            item: [
              {
                name: "Chấm công sinh trắc học CheckID FacialSense",
              },
              {
                name: "Quản lý khách truy cập CheckID FacialSense",
              },
            ],
          },
        ],
      },
    ],
    industries: "Ngành nghề",
    subindustries: [
      {
        name: "Chấm công SINH TRẮC HỌC CHECKID FACIALSENSE",
        item: [
          {
            name: "",
            item: [
              {
                name: "Nhân viên văn phòng",
              },
              {
                name: "Nhân viên bán lẻ",
              },
              {
                name: "Nhân viên di động và làm việc từ xa",
              },
              {
                name: "Điểm danh học sinh",
              },
              {
                name: "Công trường xây dựng",
              },
              {
                name: "Dịch vụ chăm sóc sức khỏe",
              },
              {
                name: "Dịch vụ Khách sạn",
              },
              {
                name: "Nhà máy và Kho hàng",
              },
              {
                name: "Nông nghiệp",
              },
            ],
          },
        ],
      },
      {
        name: "QUẢN LÝ KHÁCH TRUY CẬP CHECKID FACIALSENSE",
        item: [
          {
            name: "",
            item: [
              {
                name: "Tổ chức",
              },
              {
                name: "Du lịch và tham quan",
              },
              {
                name: "Ngân hàng và tổ chức tài chính",
              },
              {
                name: "Khách sạn và nhà hàng",
              },
              {
                name: "Dịch vụ tư vấn",
              },
              {
                name: "Tòa nhà và căn hộ",
              },
              {
                name: "Hỗ trợ khách hàng",
              },
              {
                name: "Giải trí",
              },
              {
                name: "Trường học và cơ sở",
              },
            ],
          },
        ],
      },
    ],
    pricing: "Giá cả",
    subpricing: [
      {
        name: "giá cả",
        item: [
          {
            name: "",
            item: [
              {
                name: "Chấm công sinh trắc học CheckID FacialSense",
              },
              {
                name: "Quản lý khách truy cập CheckID FacialSense",
              },
            ],
          },
        ],
      },
    ],
    resources: "Tài nguyên",
    subresources: [
      {
        name: "sản phẩm",
        item: [
          {
            name: "Chấm công SINH TRẮC HỌC CHECKID FACIALSENSE",
            item: [
              {
                name: "Máy chủ tại chỗ",
              },
              {
                name: "Khách hàng tiêu chuẩn",
              },
              {
                name: "Khách hàng Lite",
              },
            ],
          },
          {
            name: "QUẢN LÝ KHÁCH TRUY CẬP CHECKID FACIALSENSE",
            item: [
              {
                name: "Máy chủ tại chỗ",
              },
              {
                name: "Khách truy cập",
              },
              {
                name: "Khách hàng Visitor Lite",
              },
            ],
          },
          {
            name: "KHÁC",
            item: [
              {
                name: "Khách hàng giám sát CheckID FacialSense",
              },
              {
                name: "Bảo vệ CheckID FacialSense",
              },
              {
                name: "Trình điều khiển máy quét",
              },
              {
                name: "Mẫu nhà phát triển",
              },
              {
                name: "Các phiên bản trước",
              },
            ],
          },
        ],
      },
      {
        name: "TƯ LIỆU",
        item: [
          {
            name: "HƯỚNG DẪN NGƯỜI DÙNG",
            item: [
              {
                name: "Chấm công sinh trắc học CheckID FacialSense",
              },
              {
                name: "Quản lý khách hàng CheckID FacialSense",
              },
              {
                name: "Hướng dẫn dành cho nhà phát triển",
              },
            ],
          },
          {
            name: "KHÁC",
            item: [
              {
                name: "Tích hợp bảng lương",
              },
              {
                name: "Báo cáo chấm công",
              },
              {
                name: "Tích hợp bên thứ ba",
              },
              {
                name: "Thiết bị được hỗ trợ",
              },
            ],
          },
        ],
      },
      {
        name: "HƯỚNG DẪN BẮT ĐẦU NHANH",
        item: [
          {
            name: "Chấm công SINH TRẮC HỌC CHECKID FACIALSENSE",
            item: [
              {
                name: "Đám mây",
              },
              {
                name: "Tại chỗ",
              },
            ],
          },
          {
            name: "QUẢN LÝ KHÁCH TRUY CẬP CHECKID FACIALSENSE",
            item: [
              {
                name: "Đám mây",
              },
              {
                name: "Tại chỗ",
              },
            ],
          },
        ],
      },
    ],
    company: "Công ty",
    subcompany: [
      {
        name: "Công ty",
        item: [
          {
            name: "",
            item: [
              {
                name: "Về chúng tôi",
              },
              {
                name: "Liên hệ",
              },
              {
                name: "Tài liệu tham khảo của khách hàng",
              },
              {
                name: "Đăng ký làm nhà phân phối",
              },
              {
                name: "Tin tức và cập nhật",
              },
              {
                name: "Tin tức",
              },
            ],
          },
        ],
      },
    ],
    login: "Đăng nhập",
    signup: "Đăng ký",
  },

  homepage: {
    solution: {
      header:
        "Giải pháp chấm công và quản lý khách hàng sử dụng công nghệ nhận diện đa sinh trắc học",
      description:
        "Sử dụng đơn giản và dễ tích hợp, các giải pháp đa sinh trắc học CheckID FacialSense cung cấp khả năng quản lý thời gian của nhân viên và khách ra vào nhanh chóng, an toàn.",
      get: "Bắt đầu miễn phí ngay bây giờ!",
      request: "Yêu cầu bản demo",
      janedoe: "Jane Doe",
      employee: "Nhân viên",
      checkin: "Chấm công",
      day1: "Thứ Sáu, 12 tháng 8, 2022",
      visitor: "Khách truy cập",
      welcome: "Chào mừng",
      totalhours: "Tổng giờ",
      workhours: "Giờ làm việc",
      vacation: "Kỳ nghỉ",
    },
    product: {
      our: " của chúng tôi",
      products: "Sản phẩm",
      header: "Hệ Thống Quản Lý Chấm Công Đa Sinh Trắc Học",
      description:
        " CheckID FacialSense BioAttendance là hệ thống quản lý chấm công sinh trắc học được thiết kế để đăng ký và quản lý việc chấm công của nhân viên bằng cách sử dụng nhận dạng sinh trắc học khuôn mặt, dấu vân tay và mống mắt.",
      features: {
        header: "Các tính năng mạnh mẽ:",
        feature1: "Nhận dạng chấm công khuôn mặt, vân tay và mống mắt",
        feature2: "Theo dõi dựa trên vùng địa lý và định vị",
        feature3: "Không tiếp xúc và an toàn vệ sinh",
        feature4: "Nhận diện khi đeo khẩu trang",
        feature5: "Nhận diện thực thể sống",
        feature6: "Nhận diện khuôn mặt theo thời gian thực",
        feature7: "Ngăn chặn gian lận",
        feature8: "Nhận diện nhiều khuôn mặt",
        feature9: "Báo cáo nâng cao",
      },
      learnmore: "Tìm hiểu thêm",
    },
    visitor: {
      header:
        "Hệ Thống Quản lý khách ra vào Dựa Trên Nhận Diện Sinh Trắc Học",
      description:
        "Hệ thống Quản lý khách ra vào sử dụng công nghệ nhận diện khuôn mặt, dấu vân tay và mống mắt để đăng ký, giám sát và quản lý khách ra vào, các cuộc hẹn của họ, điểm danh và kiểm soát ra vào của bất kỳ tổ chức hoặc học viện nào.",
      description1:
        "Nó có thể được sử dụng để quản lý bất kỳ loại khách ra vào nào, chẳng hạn như khách hàng, khách mời, người tham dự, nhà cung cấp và hành khách.",
      features: {
        header: "Tính năng mạnh mẽ:",
        feature1: "Nhận dạng khách truy cập an toàn",
        feature2: "Phân tích dữ liệu khách truy cập theo thời gian thực",
        feature3: "Đặt lịch trực tuyến cho khách truy cập",
        feature4: "Quầy đăng ký khách truy cập",
        feature5: "Kiểm soát ra vào cho khách",
        feature6: "Lập nhật ký ra vào",
        feature7: "Quầy thông tin khách truy cập",
        feature8: "Thông báo thời gian thực",
        feature9: "Lập kế hoạch nâng cao",
        feature10:
          "Quản lý tự động thời gian hẹn và hàng chờ của khách",
      },
      learnmore: "Tìm hiểu thêm",
      johnsmith: "John Smith",
      checkid: "CheckID FacialSense VMS",
      now: "Hiện nay",
      des: "Đây là một lời nhắc rằng bạn có một cuộc hẹn được lên lịch vào ngày mai lúc 10 giờ sáng.",
    },
    benefit: {
      header: {
        bio: " của hệ thống nhận diện sinh trắc học",
        benefit: "Lợi ích",
      },
      items: {
        0: {
          header: "Dành cho tổ chức",
          context: [
            {
              label: "Sinh trắc học khuôn mặt",
              text: "chấm công với camera tích hợp. Không yêu cầu phần cứng độc quyền.",
            },
            {
              label: "Độ chính xác và bảo mật cao",
              text: "nhận dạng sinh trắc học bằng khuôn mặt, dấu vân tay hoặc mống mắt mang lại nhận dạng có độ chính xác cao và đáng tin cậy.",
            },
            {
              label: "Không cần thẻ hay bảng tên truyền thống",
              text: "nhận dạng sinh trắc học ngăn chặn hành vi gian lận chấm công thay người khác.",
            },
            {
              label: "Nhận dạng khách truy cập thụ động",
              text: "giám sát chấm công với số lượng lớn với tính năng nhận dạng nhiều khuôn mặt cùng lúc bằng camera giám sát.",
            },
          ],
        },
        1: {
          header: "Dành cho nhân viên",
          context: [
            {
              label: "Dễ sử dụng",
              text: "không lo mất hoặc quên thẻ/bảng tên, chỉ cần dùng sinh trắc học để ghi nhận chấm công.",
            },
            {
              label: "Chính xác",
              text: "ghi nhận sinh trắc học khi chấm công đảm bảo việc chấm công của bạn được theo dõi chính xác.",
            },
            {
              label: "Mọi lúc, mọi nơi",
              text: "chấm công ở mọi lúc mọi nơi bằng điện thoại thông minh cá nhân.",
            },
            {
              label: "Chấm công không tiếp xúc",
              text: "Quét sinh trắc học khuôn mặt và mống mắt không tiếp xúc mang lại trải nghiệm chấm công an toàn vệ sinh hơn.",
            },
            {
              label: "Theo dõi thời gian ngoại tuyến",
              text: "CheckID FacialSense ghi nhận chấm công theo thời gian thực ngay cả khi mất kết nối và sẽ đồng bộ ngay khi có kết nối trở lại.",
            },
          ],
        },
        2: {
          header: "Dành cho khách ra vào",
          context: [
            {
              label: "Tiện lợi",
              text: "dễ dàng đặt lịch hẹn từ mọi nơi, mọi lúc.",
            },
            {
              label: "Cảnh báo",
              text: "hệ thống sẽ nhắc nhở bạn về các cuộc hẹn trong trường hợp bạn quên chúng.",
            },
            {
              label: "Ghi nhận không tiếp xúc",
              text: "quét khuôn mặt hoặc mống mắt của khách cung cấp giải pháp ghi nhận ra vào an toàn vệ sinh hơn.",
            },
            {
              label: "Bảo mật",
              text: "xác thực sinh trắc học khuôn mặt, vân tay hoặc mống mắt đảm bảo chỉ người khách mới được phép truy cập thông tin của mình.",
            },
            {
              label: "Trải nghiệm được cá nhân hóa",
              text: "khách nhận thông tin được cá nhân hóa bằng cách sử dụng nhận dạng sinh trắc học.",
            },
          ],
        },
      },
    },
    testimonials: {
      header: "Đánh giá",
      items: [
        {
          description:
            "CheckID FacialSense cung cấp một giải pháp hoàn chỉnh để giám sát và kiểm soát công việc của nhân viên trong văn phòng, các cơ sở giáo dục và y tế, khách sạn và nhà máy. Bằng cách sử dụng công nghệ quét đa phương tiện, bạn có thể giảm thiểu rủi ro xâm nhập của bên thứ ba vào công ty.",
          name: "Alex Bern",
          position: "Quản lý Bộ phận Đối tác tại Fixthephoto.com",
        },
        {
          description:
            "“Chúng tôi đang sử dụng phần mềm này cho nhiều địa điểm khác nhau và cho đến nay nó hoạt động khá tốt. Tôi ước rằng có thêm một vài tính năng nữa, nhưng nhìn chung thì phù hợp cho các tổ chức nhỏ và vừa.”",
          name: "Rajeev S.",
          position: "Tổng Giám đốc Tài chính",
        },
        {
          description:
            "“Chúng tôi đang sử dụng phần mềm này trong trường học của mình để chấm công nhân viên và thấy rất hữu ích. Phần mềm này đăng ký tất cả thông tin chi tiết và nhận diện sinh trắc học của nhân viên chúng tôi nhanh chóng và ngay lập tức chúng tôi bắt đầu chấm công nhân viên của mình. Chúng tôi đã theo dõi được sự vắng mặt và những người đến trễ của nhân viên. Chúng tôi đã có thể xem báo cáo chấm công hàng ngày một cách nhanh chóng mà không gặp khó khăn nào.”",
          name: "Seema C.",
          position: "Giáo viên, Trường Trung học Red Roses",
        },
        {
          description:
            "“Trước đây khi chúng tôi sử dụng hệ thống thời gian và chấm công truyền thống, tôi phải làm nhiều công việc để đồng bộ báo cáo. Nhưng với CheckID FacialSense, chúng tôi chỉ cần vài cú nhấp chuột.”",
          name: "Priya P.",
          position: "Smartcard IT India",
        },
        {
          description:
            "“Nhận diện khuôn mặt hoạt động tốt ngay cả với camera thông thường. Rất tiện lợi, tiết kiệm chi phí và đáng giá so với số tiền bỏ ra. Độ chính xác cao. Hệ thống hỗ trợ sinh trắc học bằng khuôn mặt, vân tay và mống mắt.”",
          name: "Rakesh B.",
          position: "Quản lý - Bộ phận Bán hàng & Tiếp thị, BioScan Solution",
        },
        {
          description:
            "“Đây là phần mềm hoàn hảo cho bất kỳ ai hay công ty nào có thông tin cần được giữ bí mật. Mọi thứ đều luôn được cập nhật. Không có chỗ nào chê! Đây chắc chắn là phần mềm tốt nhất cho bất kỳ điều gì mà bạn coi trọng.”",
          name: "Marcus D.",
          position: "Công nghệ Thông tin, Trường Ogle",
        },
        {
          description:
            "“Độ chính xác trong việc nhận diện khuôn mặt và dấu vân tay. Ngoài ra còn có nhận diện mống mắt, nhận diện nhiều khuôn mặt cùng lúc trên thiết bị di động.”",
          name: "Rakesh B.",
          position: "TRƯỞNG PHÒNG - BỘ PHẬN MARKETING",
        },
        {
          description:
            "“Chúng tôi đang sử dụng sản phẩm này cho mục đích chấm công, nó được thiết kế theo cách mà bất kỳ ai cũng có thể dễ dàng thiết lập cho tổ chức của họ. Chúng tôi đang sử dụng công nghệ nhận diện khuôn mặt để xác thực. Ứng dụng di động cũng rất hữu ích cho các nhân viên làm việc ngoài hiện trường. Nó cho phép chúng tôi dễ dàng ghi nhận tất cả nhân viên ngoài hiện trường, từ đó hỗ trợ xử lý bảng lương trơn tru dựa trên dữ liệu này.”",
          name: "Kishan G.",
          position:
            "Công nghệ Thông tin và Dịch vụ, Innova Systems (Ấn Độ) Pvt. Ltd.",
        },
        {
          description:
            "“Giải pháp chấm công sinh trắc học CheckID FacialSense xuất sắc để hỗ trợ trên cả hai nền tảng Windows và Android. Một giải pháp duy nhất cho tất cả các nhu cầu dựa trên sinh trắc học. Cần tối ưu hóa về mặt chi phí theo yêu cầu cụ thể về sinh trắc học cho thời gian và chấm công.”",
          name: "Piyush K.",
          position: "CEO, Sinh học Ứng dụng Công nghệ, Saral Infotech",
        },
        {
          description:
            "“Ứng dụng rất tốt với nhiều tính năng vượt trội hơn so với các ứng dụng khác. Cần một số cải tiến nhỏ và chỉnh sửa.”",
          name: "Shiv Kumar S.",
          position: "An ninh Mạng và Máy tính",
        },
        {
          description:
            "“Hệ thống CheckID FacialSense có thể tạo ra bước đột phá cho phần mềm chấm công của nhân viên nhờ các tính năng của nó, rất dễ sử dụng, dễ cập nhật và dễ hướng dẫn cho nhân viên. Tuy nhiên, cần cải thiện một chút ở phần hướng dẫn sử dụng, màu sắc trên giao diện và cần có thêm các menu tùy chỉnh khi lập trình chấm công.”",
          name: "Mary Ann R.",
          position: "Trợ lý điều hành, Hội đồng Địa phương Reina Mercedes",
        },
      ],
    },
    question: {
      header: {
        frequently: " thường gặp",
        asked: "Câu hỏi",
      },
      description: " Mọi thứ bạn cần biết về sản phẩm và thanh toán.",
      items: [
        {
          header:
            "Tại sao chúng ta cần nhận dạng sinh trắc học cho khách ra vào?",
          body: "Nhận dạng sinh trắc học đơn giản là để đảm bảo rằng đúng người thật đang có mặt. Tất cả các hệ thống cũ khác hoặc không có khả năng nhận dạng người hoặc có khả năng cao xảy ra giả mạo. Thiệt hại do các hành vi gian lận này gây ra có thể lớn hơn nhiều so với khoản tiền lương bị mất.",
        },
        {
          header:
            "Tại sao chúng ta cần chọn chấm công sinh trắc học của CheckID FacialSense?",
          body: "Nhận dạng khuôn sinh trắc học trong chấm công nhân viên hoặc khách truy cập cần có sự đảm bảo về việc nhận dạng khuôn chính xác. CheckID FacialSense sử dụng thuật toán công nghệ nhận dạng khuôn sinh trắc học do Mobile-ID phát triển. CheckID FacialSense hỗ trợ nhận dạng khuôn sinh trắc học khuôn mặt, dấu vân tay và mống mắt. Việc hỗ trợ tất cả các phương tiện là một ưu điểm khi sử dụng trong bất kỳ yêu cầu và môi trường an ninh nào. Có nhiều ưu điểm khác kết hợp với nhận dạng khuôn sinh trắc học như nhận dạng khuôn khẩu trang, mũ bảo hộ, kính, độ tuổi, giới tính, ...",
        },
        {
          header:
            "Chúng ta có nhận được hỗ trợ miễn phí cho các sản phẩm của CheckID FacialSense không?",
          body: "Đội ngũ hỗ trợ sản phẩm CheckID FacialSense cung cấp dịch vụ trực tuyến, qua email và điện thoại miễn phí. Nếu bạn cần hỗ trợ ưu tiên với mức dịch vụ cao hơn, bạn có thể đăng ký gói hỗ trợ ưu tiên 24/7 có trả phí.",
        },
        {
          header:
            "Chúng ta có thể nhận được phiên bản tùy chỉnh của sản phẩm CheckID FacialSense không?",
          body: "Sản phẩm CheckID FacialSense có khả năng cấu hình cao và có thể tùy chỉnh theo nhiều yêu cầu riêng của bạn, chẳng hạn như thay đổi thông tin nhập liệu của người dùng, thêm cột trong báo cáo, thay đổi công thức tính toán của một trường trong báo cáo, v.v. CheckID FacialSense cũng có thể mở rộng cho các yêu cầu đặc thù của bạn thông qua các mô-đun mở rộng, cho phép bổ sung tính năng mà không ảnh hưởng đến khả năng cập nhật sản phẩm.",
        },
        {
          header: "Bạn có chương trình đại lý không?",
          body: "Chúng tôi có nhà phân phối, đại lý và đơn vị tích hợp tại nhiều quốc gia. Nếu bạn muốn tìm hiểu về họ hay muốn trở thành đại lý, đơn vị tích hợp hoặc nhà phân phối, vui lòng liên hệ với chúng tôi.",
        },
      ],
    },
    faq: {
      header: "Vẫn còn câu hỏi?",
      description:
        "Liên hệ ngay với chúng tôi để biết thêm chi tiết - chúng tôi ở đây để hỗ trợ bạn.",
      contact: "Liên hệ với chúng tôi",
    },
  },
  products: {
    facialsensevisitormanagement: {
      titlepage:
        "Hệ thống quản lý khách hàng sử dụng công nghệ nhận diện khuôn mặt CheckID FacialSense | Dịch vụ CheckID FacialSense",
      solution: {
        header:
          "Hệ thống quản lý khách hàng sử dụng công nghệ nhận diện khuôn mặt CheckID FacialSense",
        description:
          "Giải pháp chính xác và hiệu quả để quản lý các cuộc hẹn và cung cấp quyền ra vào cho khách hàng",
        get: "Thử nghiệm miễn phí",
        request: "Yêu cầu bản demo",
        janesmith: "John Smith",
        visitor: "Khách truy cập",
        welcome: "Chào mừng",
        day: "Thứ Sáu, ngày 12 tháng 8 năm 2022",
        time: "07:55:41 AM",
        checkid: "CheckID FacialSense VMS",
        titlecheckid:
          "Đây là lời nhắc rằng bạn có một cuộc hẹn được lên lịch vào ngày mai lúc 10 giờ sáng.",
        time1: "Hiện nay",
      },
      benefits: {
        header:
          " của hệ thống quản lý khách hàng sử dụng công nghệ nhận diện khuôn mặt",
        benefitheader: "Các lợi ích",
        institution: "Đối với tổ chức",
        titlesecurity: "Bảo mật",
        security:
          " - khách truy cập được xác thực trước khi vào cơ sở, do đó chỉ đảm bảo quyền truy cập của những người được ủy quyền.",
        titleappointment: "Dễ dàng đặt lịch hẹn không phiền phức",
        appointment: " - hệ thống tự động quản lý các khung giờ.",
        titleincrease: "Tăng hiệu suất theo dõi chấm công",
        increase:
          " - sử dụng nhận diện bằng quan sát thông minh sử dụng camera giúp theo dõi các nhóm nhân sự lớn một cách dễ dàng.",

        user: "Đối với người dùng",
        titleconvenience: "Thuận tiện",
        convenience: " - dễ dàng đặt hẹn từ bất kỳ đâu và bất kỳ lúc nào.",
        titleautomatic: "Cảnh báo tự động",
        automatic:
          " - hệ thống sẽ nhắc bạn về các cuộc hẹn, trong trường hợp bạn quên điều đó.",
        titlecontactless: "Check-in không tiếp xúc ",
        contactless:
          " - quét đa phương thức giúp tạo ra một giải pháp vệ sinh hơn để ra vào cơ sở.",
      },
      systemserver: {
        header:
          "Máy chủ hệ thống quản lý khách hàng sử dụng công nghệ nhận diện khuôn mặt",

        cloud: "Đám mây",
        descriptioncloud:
          "Quản lý và xác thực sinh trắc học của khách ra vào với hệ thống kiểm soát truy cập dưới dạng dịch vụ đám mây.",
        monthly: "Đăng ký hàng tháng",
        subscription: "Giá đăng ký phụ thuộc vào số lượng khách truy cập",
        free: "Đăng ký miễn phí hỗ trợ tới 5 cuộc hẹn",
        support:
          "Hỗ trợ cho khách hàng của CheckID FacialSense Visitor Management",
        noneed:
          "Không cần lo lắng về việc cài đặt máy chủ và không cần bảo trì.",
        signup: "Đăng ký",

        premises: "Tại cơ sở",
        descriptionpremises:
          "Hệ thống quản lý và xác thực khách ra vào sinh trắc học với kiểm soát ra vào có thể được lưu trữ tại cơ sở của riêng bạn.",
        one: "Mua một lần",
        nolimitation: "Không giới hạn về số lượng cuộc hẹn",
        needno: "Tự cài đặt máy chủ",
        support1:
          "Hỗ trợ cho khách hàng của CheckID FacialSense Visitor Management",
        customer:
          "Khách hàng có quyền tự do cài đặt và cấu hình máy chủ Hệ thống Quản lý Khách hàng sử dụng công nghệ nhận diện khuôn mặt",
        download: "Tải bản dùng thử",
      },
      quickstartguide: {
        header: "Hướng dẫn bắt đầu nhanh chóng",
        description:
          "Hướng dẫn từng bước được cung cấp để bạn có thể bắt đầu sử dụng hệ thống quản lý khách ra vào sử dụng công nghệ nhận diện sinh trắc học CheckID FacialSense.",
        cloud: "Đám mây",
        onpremises: "Tại cơ sở",
      },

      fearures: {
        header:
          " của hệ thống quản lý khách hàng",
        subheader:
          "sử dụng công nghệ nhận diện khuôn mặt",
        featureheader: "Các tính năng",
        description:
          "Đội ngũ giàu kinh nghiệm và chuyên nghiệp của chúng tôi đã phát triển một phần mềm hoạt động quản lý khách ra vào sử dụng công nghệ nhận diện khuôn mặt đầy đủ các tính năng độc đáo để đưa quản lý khách hàng của doanh nghiệp bạn lên một tầm cao mới",
        titlesecure: "Bảo vệ quyền ra vào của khách",
        secure:
          "Nhận dạng bằng mã vạch, RFID, khuôn mặt, vân tay và mống mắt cung cấp quyền ra vào nhanh chóng, hiệu quả và an toàn cho các cuộc hẹn của khách cũng như các tương tác với khách.",
        titlesafe: "An toàn và vệ sinh",
        safe: "Công nghệ nhận diện khách không tiếp xúc bằng mã vạch, RFID, khuôn mặt và mống mắt giúp xác thực khách mà không cần chạm.",
        titleonline: "Đặt hẹn trước trực tuyến",
        online:
          "Việc đặt lịch hẹn trước trực tuyến cho phép khách lên kế hoạch cho chuyến thăm từ trước và ra vào một cách thuận tiện",
        titleautomated: "Kiểm soát truy cập tự động",
        automated:
          "Các cổng hạn chế và cho phép khách ra vào được kiểm soát bằng các thiết bị chấm công.",
        titlerealtime: "Phân tích dữ liệu khách theo thời gian thực",
        realtime:
          "Thiết bị chấm công của khách ghi lại các trường hợp được cấp quyền hoặc từ chối quyền ra vào trong hệ thống.",
        titleelectronic: "Thẻ điện tử",
        electronic:
          "Tự động tạo thẻ hoặc sử dụng các loại thẻ điện tử xác định như mã vạch, RFID và biển số xe làm thẻ khách.",
        titledata: "Bảo mật dữ liệu",
        data: "Các hoạt động liên quan đến khách được thực hiện bởi nhân sự được ủy quyền, đảm bảo thông tin về khách và chuyến thăm được bảo vệ khỏi việc ra vào trái phép.",
        titlebiometric:
          "Nhận dạng khách bằng sinh trắc học",
        biometric:
          "Hệ thống kiểm soát và quản lý sử dụng nhiều công nghệ nhận diện khuôn mặt, vân tay và mống mắt.",
        titlecustomizable: "Ghi chú chuyến thăm có thể tùy chỉnh",
        customizable:
          "Các ghi chú về chuyến thăm được tùy chỉnh kèm theo biểu mẫu và tệp đính kèm có thể được sử dụng để tạo nhật ký chi tiết về khách ra vào.",
      },
      applications: {
        header: "Ứng dụng và các ngành",
        applica: "Ứng dụng và",
        insdus: " công nghiệp",
        description:
          "Hệ thống chấm công Sinh học của chúng tôi phù hợp để áp dụng trong nhiều doanh nghiệp và tổ chức khác nhau.",
        organizations: "Tổ chức",
        travel: "Du lịch và chuyến đi",
        hotel: "Khách sạn và nhà hàng",
        consulting: "Dịch vụ tư vấn",
        bank: "Ngân hàng",
        building: "Công trình và căn hộ",
        school: "Trường học và khuôn viên",
        customer: "Hỗ trợ khách hàng",
      },

      askedquestions: {
        header: "Câu hỏi thường gặp",
        description: "Mọi thông tin bạn cần biết về sản phẩm và thanh toán.",

        howi: "Hệ thống quản lý khách hàng có hỗ trợ đám mây không?",
        howides: "Có.",
        howcan: "Có thể triển khai trên nền tảng di động không?",
        howcandes:
          "Có, ứng dụng quản lý khách hàng CheckID FacialSense cho Windows và Android cung cấp các chức năng quản lý khách ra vào sau đây:",
        howcandes1: "Kiosk đăng ký khách ra vào",
        howcandes2:
          "Quét sinh trắc học và kiểm soát ra vào cho khách",
        howcandes3: "Hiển thị thông tin khách",
        howcandes4: "Trợ lý cho khách",

        cani: "Hệ thống có phải hoàn toàn không tiếp xúc và không dùng giấy không?",
        canides: "Hệ thống của chúng tôi không tiếp xúc và không dùng giấy.",
        canides1:
          "Đăng ký ra vào bằng sinh trắc học, sử dụng khuôn mặt hoặc thiết bị quét mống mắt/dấu vân tay không chạm.",
        canides2: "Hỗ trợ đăng ký trực tuyến từ thiết bị cá nhân của khách.",
        canides3: "Gửi email thông báo thẻ ra vào của khách dưới dạng mã QR để sử dụng khi cần.",
        canides4: "Đăng ký khách ra vào bằng thẻ định danh RFID cá nhân của họ.",

        whatare:
          "Hệ thống có thể tùy chỉnh mà không tốn phí hoặc tốn ít phí không?",
        whataredes:
          "Có, hệ thống có cấu hình cao cho các yêu cầu khác nhau. Bất kỳ yêu cầu cụ thể nào của khách hàng đều có thể được thêm vào với tiện ích mở rộng mà không cần làm ảnh hưởng đến khả năng cập nhật sản phẩm nào trong tương lai.",
        isit: "Hệ thống có thể mở rộng được không?",
        desisit:
          "Hệ thống quản lý khách truy cập CheckID FacialSense được xây dựng dựa trên kiến trúc dịch vụ vi mô và có thể mở rộng đến bất kỳ quy mô nào.",
      },
      still: {
        header: "Vẫn còn câu hỏi?",
        description:
          "Liên hệ với chúng tôi ngay bây giờ để mọi thắc mắc - chúng tôi ở đây để giúp bạn.",
        contact: "Liên hệ với chúng tôi",
      },
    },
    bioattendance: {
      titlepage:
        "CheckID FacialSense Hệ thống chấm công sinh trắc học | Dịch vụ CheckID FacialSense",
      intro: {
        header: "CheckID FacialSense hệ thống chấm công sinh trắc học",
        description:
          "Giải pháp chính xác và hiệu quả cho đăng ký, quản lý thời gian và chấm công.",
        button: "Thử miễn phí",
      },
      benefits: {
        header: {
          bio: " hệ thống Quản lý Khách và Nhân viên qua Sinh trắc học",
          benefit: "Lợi ích",
        },
        body: [
          {
            title: "Đối với tổ chức",
            content: [
              {
                title: "Tiết kiệm chi phí",
                content:
                  "Không cần thẻ ID, thẻ nhận dạng hoặc trang thiết bị khác cho người dùng hệ thống, họ chỉ cần sử dụng sinh trắc học.",
              },
              {
                title: "Độ chính xác và bảo mật cao",
                content:
                  "Nhận diện dựa trên sinh trắc học đa phương tiện giúp đạt được độ chính xác rất cao và đáng tin cậy để ngăn chặn gian lận.",
              },
              {
                title: 'Không còn tình trạng “chấm công hộ”',
                content:
                  "Không ai có thể giả mạo việc chấm công vào/ra thay cho nhân viên/người dùng/người tham dự khác.",
              },
              {
                title: "Tích hợp hữu ích",
                content:
                  "CheckID FacialSense cung cấp khả năng xuất dữ liệu linh hoạt sang nhiều hệ thống tính lương phổ biến.",
              },
              {
                title: "Tăng hiệu quả giám sát chấm công",
                content:
                  "Việc sử dụng nhận diện và nhận dạng thụ động kết hợp với camera giám sát giúp dễ dàng quản lý số lượng lớn nhân sự.",
              },
            ],
          },
          {
            title: "Đối với người sử dụng",
            content: [
              {
                title: "Dễ sử dụng",
                content: "Không còn lo quên thẻ chấm công.",
              },
              {
                title: "Chính xác",
                content:
                  "Việc sử dụng nhận diện khuôn mặt, vân tay hoặc mống mắt đảm bảo rằng thời gian làm việc của bạn được ghi lại chính xác.",
              },
              {
                title: "Mọi lúc mọi nơi",
                content:
                  "ghi nhận chấm công từ bất kỳ đâu mà bạn đang làm việc bằng điện thoại thông minh cá nhân.",
              },
              {
                title: "Chấm công không tiếp xúc",
                content:
                  "Quét đa phương thức mang đến giải pháp giám sát chấm công vệ sinh và tiện lợi hơn. ",
              },
              {
                title: "Chấm công ngoại tuyến",
                content:
                  "Không cần lo lắng về việc mất kết nối dẫn đến bỏ lỡ ghi nhận chấm công hoặc ảnh hưởng đến lương. Giải pháp chấm công sinh trắc học CheckID FacialSense ghi nhận dữ liệu chấm công một cách an toàn ngay cả khi ngoại tuyến.",
              },
            ],
          },
        ],
      },

      clientHeader: "Máy khách BioAttendance",
      client: [
        {
          header: "Đám mây",
          title:
            "Hệ thống quản lý nhân viên và kiểm soát truy cập sinh trắc học dưới dạng dịch vụ đám mây.",
          content: [
            { title: "Đăng ký hàng tháng" },
            { title: "Giá đăng ký phụ thuộc vào số lượng nhân viên" },
            { title: "Đăng ký miễn phí hỗ trợ tối đa 5 người dùng" },
            {
              title:
                "Hỗ trợ ứng dụng khách CheckID FacialSense Standard và Lite",
            },
            {
              title:
                "Không cần lo lắng về cài đặt máy chủ và không cần bảo trì.",
            },
          ],
          button: "Đăng ký",
        },
        {
          header: "Tại cơ sở",
          title:
            "Hệ thống quản lý nhân viên và kiểm soát truy cập sinh trắc học có thể tự lưu trữ trên máy chủ của bạn.",
          content: [
            { title: "Mua một lần" },
            { title: "Không có giới hạn về số lượng nhân viên" },
            { title: "Cần một máy tính để cài đặt phần mềm máy chủ" },
            {
              title:
                "Hỗ trợ ứng dụng khách CheckID FacialSense Standard và Lite",
            },
            {
              title: "Khách hàng có tự do cấu hình máy chủ theo ý muốn của họ",
            },
          ],
          button: "Tải bản thử nghiệm",
        },
      ],
      serverHeader: "Máy chủ BioAttendance",
      server: {
        header: {
          parameters: "Tham số",
          standard: "CheckID FacialSense Standard",
          lite: "CheckID FacialSense Lite",
        },
        body: [
          {
            parameters: "Sinh trắc học",
            standard: "khuôn mặt, vân tay, mống mắt",
            lite: "khuôn mặt",
          },
          { parameters: "Tự động phát hiện và chụp khuôn mặt" },
          { parameters: "Phát hiện sự sống của khuôn mặt" },
          { parameters: "Nhận diện tất cả mọi người từ ảnh nhóm" },
          { parameters: "Theo dõi vùng địa lý /n (Hạn chế vị trí)" },
          { parameters: "Ghi nhận vị trí GPS" },
          { parameters: "Ghi lại chấm công ngoại tuyến" },
          {
            parameters: "Hỗ trợ hệ điều hành",
            standard: "Windows, Android",
            lite: "Windows, Android, iOS",
          },
          { parameters: "Hoạt động độc lập" },
          { parameters: "Kiểm soát truy cập" },
          { parameters: "Chế độ kiosk" },
          { parameters: "RFID, Mã vạch" },
          { parameters: "Thiết bị cá nhân /n (Sử dụng thiết bị của bạn)" },
          { parameters: "Giá", standard: "95 EUR / cài đặt", lite: "Miễn phí" },
        ],
      },

      features: {
        header: "Tính năng",
        description:
          "Các tính năng độc đáo của sản phẩm của chúng tôi đưa theo dõi thời gian và chấm công lên một tầm cao mới.",
        body: [
          {
            title: "Nhận diện khi đeo khẩu trang",
            description:
              "Hệ thống chấm công sinh trắc học của chúng tôi có thể nhận diện một người ngay cả khi họ đang đeo khẩu trang, đảm bảo việc nhận diện an toàn và sạch sẽ.",
          },
          {
            title: "Không tiếp xúc và sạch sẽ",
            description:
              "Không cần tiếp xúc vật lý khi người được nhận diện qua khuôn mặt hoặc mống mắt.",
          },
          {
            title: "Quản lý chấm công từ xa",
            description:
              "Thời gian làm việc của nhân viên có thể được theo dõi và tính toán dễ dàng ngay cả khi người đó làm việc từ xa. Người dùng có thể đăng ký và trả phòng đơn giản bằng thiết bị di động, máy tính bảng hoặc máy tính cá nhân.",
          },
          {
            title: "Nhiều phương thức sinh trắc học",
            description:
              "Có 3 phương thức sinh trắc học - khuôn mặt, ngón tay và mống mắt",
          },
          {
            title: "Theo dõi vị trí",
            description:
              "Báo cáo bao gồm tổng hợp giờ làm việc, làm thêm giờ, nghỉ phép, nghỉ ốm và các thông tin liên quan khác có thể được xuất sang hệ thống lương.",
          },
          {
            title: "Báo cáo toàn diện",
            description:
              "Hệ thống chấm công của chúng tôi có thể theo dõi vị trí địa lý nơi người đó đăng ký/đăng xuất.",
          },
          {
            title: "Phát hiện sự sống",
            description:
              "Trước khi bắt đầu nhận diện khuôn mặt, hệ thống có thể xác nhận rằng việc đăng ký đang được thực hiện bởi một người thật.",
          },
          {
            title: "Nhận diện thời gian thực",
            description:
              "Hệ thống có thể phát hiện khuôn mặt của một người đi qua mà không cần dừng lại và chờ camera chụp hình.",
          },
          {
            title: "Nhận diện nhiều khuôn mặt",
            description:
              "Hệ thống chấm công sinh trắc học của chúng tôi có thể phát hiện và nhận diện khuôn mặt của tất cả mọi người xuất hiện trong bức ảnh.",
          },
        ],
      },
      applicationIndustries: {
        header: {
          application: "Ứng dụng",
          and: "và",
          industries: "Ngành công nghiệp",
          industries1: "Ngành công",
          industries2: "nghiệp",
        },
        description:
          "Hệ thống Chấm công Sinh trắc học của chúng tôi có thể được sử dụng thành công bởi nhiều doanh nghiệp và tổ chức khác nhau.",
        body: [
          { title: "Văn phòng" },
          { title: "Nhà máy và Kho" },
          { title: "Lực lượng lao động di động" },
          { title: "Dịch vụ Nhà hàng & Khách sạn" },
          { title: "Nông nghiệp" },
          { title: "Công ty Xây dựng" },
          { title: "Các Tổ chức Giáo dục" },
          { title: "Tổ chức Y tế" },
          { title: "Bán lẻ" },
          { title: "Các lĩnh vực khác" },
        ],
      },
      question: [
        {
          header: "Làm thế nào để thử nghiệm FacialSense Bio Attendance?",
          body: "Bạn có thể đăng ký và sử dụng miễn phí với gói đăng ký đám mây không giới hạn thời gian (tối đa 5 người dùng) hoặc tải xuống và cài đặt phiên bản thử nghiệm, miễn phí trong 30 ngày.",
        },
        {
          header:
            "Làm thế nào để nâng cấp từ phiên bản thử nghiệm lên phiên bản trả phí?",
          body: "Đối với FacialSense Bio Attendance Cloud, chỉ cần đăng nhập và nâng cấp gói đăng ký của bạn.",
        },
        {
          header:
            "Tôi có thể sử dụng dữ liệu từ phiên bản thử nghiệm trong phiên bản trả phí không?",
          body: "Có, bạn có thể tiếp tục sử dụng dữ liệu thu thập được trong suốt thời gian dùng thử.",
        },
        {
          header: "Yêu cầu về phần mềm và phần cứng là gì?",
          body: "Hệ thống có thể chạy trên tất cả các PC Windows, máy tính bảng Windows và thiết bị Android (đối với iOS chỉ có ứng dụng khách cho nhân viên/người sử dụng). Cần có một camera để thực hiện nhận diện khuôn mặt. Hệ thống hỗ trợ webcam và camera tích hợp. Đối với việc nhận diện vân tay hoặc mống mắt, hệ thống yêu cầu một máy quét vân tay hoặc máy quét mống mắt bên ngoài. Các thiết bị được hỗ trợ được liệt kê ở đây. Khi kết nối, các thiết bị quét và camera được hỗ trợ sẽ được dò ra và cấu hình tự động.",
        },
        {
          header:
            "Có cần phải có kết nối internet để sử dụng FacialSense Bio Attendance không?",
          body: "Phiên bản trả phí On-Premises có thể chạy mà không cần kết nối internet. Kết nối internet cần thiết để kích hoạt giấy phép, sử dụng phiên bản thử nghiệm và cho phiên bản đám mây.",
        },
        {
          header:
            "Sự khác biệt giữa FacialSense Standard, FacialSense Server và FacialSense Lite là gì?",
          items: [
            {
              header: "FacialSense Standard",
              body: "- Ứng dụng chấm công đầy đủ chức năng với tất cả ba phương thức có sẵn (khuôn mặt, vân tay, mống mắt).",
            },
            {
              header: "FacialSense Server",
              body: "- Thích hợp để sử dụng trên máy chủ đã chọn của bạn và hoạt động như cơ sở dữ liệu trung tâm (bao gồm cả web cho quản trị viên).",
            },
            {
              header: "FacialSense Lite",
              body: "- Là ứng dụng đơn giản và miễn phí với thời gian không giới hạn, là một bổ sung cho các sản phẩm trả phí. Chỉ phù hợp để nhận diện người dùng (đăng ký/đăng xuất) thông qua khuôn mặt.",
            },
          ],
        },
        {
          header:
            "Trong trường hợp mất kết nối (nếu bạn chạy FacialSense Bio Attendance trên máy chủ của bạn), điều gì sẽ xảy ra?",
          body: "Bạn có thể cấu hình thiết bị để chạy ở chế độ ngoại tuyến. Khi máy chủ mất kết nối, thiết bị vẫn có thể thực hiện nhận diện nhân viên cục bộ và ghi lại dữ liệu chấm công. Phần mềm terminal chấm công cập nhật dữ liệu thu thập được ngoại tuyến ngay khi kết nối lại với máy chủ.",
        },
      ],
    },
  },

  industries: {
    biometricoffice: {
      titlepage:
        "Hệ Thống Điểm Danh Văn Phòng Bằng Sinh Trắc Học | Dịch vụ CheckID FacialSense",
      header: "Hệ Thống Điểm Danh Văn Phòng ",
      hoc: " Bằng Sinh Trắc Học",
      bio: "điểm danh văn phòng bằng sinh trắc học",
      sys: "Hệ thống điểm danh văn",
      bio2: "phòng bằng sinh trắc học",
      sys2: "hệ thống điểm danh",
      bio1: "sinh trắc học",
      off1: "văn phòng bằng ",
      bang: "bằng",
      van: "văn phòng",
      att1: "điểm danh ",
      sys1: "Hệ thống ",

      titletransrom: "Biến đổi",
      transfrom: " hệ thống chấm công văn phòng sử dụng sinh trắc học",
      transfromdes1:
        "Hệ thống chấm công văn phòng sinh trắc học CheckID FacialSense được các nhà tuyển dụng yêu thích vì khả năng duy trì và nâng cao ",
      effect: "hiệu quả, năng suất và tiết kiệm chi phí",
      workfor: " của đội ngũ lao động, không cần phần cứng chuyên dụng.",
      transfromdes2: "Hệ thống của chúng tôi hoạt động bằng cách ",
      biomatriciden:
        "sử dụng nhận diện sinh trắc học khuôn mặt, vân tay và mống mắt.",
      checkid:
        "Hệ thống chấm công văn phòng sinh trắc học CheckID FacialSense là sự tích hợp chìa khóa trao tay đơn giản vào các hoạt động nhân sự và tính lương của bạn, đảm bảo nhân viên của bạn được trả lương chính xác đồng thời loại bỏ các nút thắt trong quản lý tiền lương của bạn.",
      transfromdes3:
        "Mặc dù công nghệ sinh trắc học mang lại khả năng tiên tiến, nhưng",
      userinf: "giao diện người dùng và báo cáo lại đơn giản, trực quan và có thể tùy chỉnh",
      around:
        " theo yêu cầu kinh doanh của bạn, giúp bạn tận dụng những khả năng được trang bị bởi trí tuệ nhân tạo này cho doanh nghiệp của bạn.",
      biomatricfeature: "Các tính năng",
      biomatricfeaturekey:
        " hệ thống chấm công văn phòng ",
      biomatricfeaturekey1:
        "sử dụng sinh trắc học",
      biomatricfeaturedes:
        "Phần mềm này được thiết kế và xây dựng cẩn thận, với nhiều tính năng mạnh mẽ nhằm tăng cường hiệu suất và độ chính xác của quá trình giám sát thời gian làm việc và chấm công nhân viên trong văn phòng của bạn, bao gồm:",
      multiple: "Nhận diện nhiều khuôn mặt",
      multipledes:
        "Hệ thống chấm công văn phòng của chúng tôi có thể phát hiện và nhận diện khuôn mặt của tất cả những người xuất hiện trong hình ảnh, giúp nhân viên không phải đứng xếp hàng để sử dụng máy chấm công.",
      realtime: "Nhận diện khuôn mặt theo thời gian thực",
      realtimedes:
        "Hệ thống có thể phát hiện khuôn mặt của một người khi họ đi ngang qua mà không cần phải dừng lại chờ được chụp ảnh.",
      turnkey: "Giải pháp toàn diện",
      turnkeydes:
        "Hệ thống chấm công văn phòng CheckID FacialSense không đòi hỏi phần cứng chuyên biệt*, và dễ dàng tích hợp với các nhà cung cấp thanh toán lương hàng đầu để đảm bảo tích hợp liền mạch vào các quy trình kinh doanh tiêu chuẩn của bạn.",
      footer:
        "* Đối với nhận diện vân tay hoặc mống mắt, hệ thống yêu cầu một đầu đọc vân tay hoặc máy quét mống mắt bên ngoài, cả hai đều có thể được mua tại",
      whychosse:
        " hệ thống chấm công văn phòng sử dụng sinh trắc học của chúng tôi cho doanh nghiệp của bạn?",
      whychossetitle: "Tại sao chọn",
      why: "Tại sao",
      choose: "chọn",
      increaseemploy: "Tăng sự hài lòng của nhân viên",
      increaseemploydes:
        "Không có gì làm giảm sự hài lòng của nhân viên hơn việc tiền lương không được thanh toán đúng. Tránh những vấn đề không cần thiết về lương nhờ hệ thống quản lý thời gian chính xác, đảm bảo mọi nhân viên đều được trả lương xứng đáng cho công việc của mình.",
      streamline: "Tối ưu hóa bộ phận nhân sự",
      streamlinedes:
        "Báo cáo tùy chỉnh mà CheckID FacialSense cung cấp cho doanh nghiệp của bạn giúp bạn dễ dàng theo dõi, phân tích và nắm bắt đội ngũ lao động của mình theo thời gian thực, giảm thiểu nhu cầu sử dụng giấy tờ cồng kềnh và khó hiểu.",
      reduce: "Giảm thiểu sai sót",
      reducedes:
        "Giám sát thời gian và chấm công là một công việc đòi hỏi dữ liệu lớn, dễ phát sinh lỗi do con người. Phần mềm chấm công văn phòng bằng sinh trắc học tự động giúp giảm thiểu rủi ro sai sót, đồng thời đảm bảo việc ghi nhận và trình bày dữ liệu một cách khách quan, có hệ thống.",
      increaseproductivity: "Tăng năng suất",
      increaseproductivitydes:
        "Máy quét sinh trắc học loại bỏ khả năng “chấm công hộ” - nhân viên này chấm công thay cho nhân viên khác. Vì vậy, bạn có thể yên tâm rằng lực lượng lao động của mình thực sự làm việc đủ số giờ mà họ báo cáo.",
      cost: "Hiệu quả chi phí",
      costdes:
        "Không chỉ giảm chi phí lao động phát sinh từ các ghi nhận không chính xác, mà tính năng nhận diện nhiều khuôn mặt còn giúp giảm thiểu thời gian đứng xếp hàng để sử dụng máy chấm công.",
      compre: "Báo cáo toàn diện",
      comperdes:
        "Báo cáo bao gồm tóm tắt về giờ làm việc, làm thêm giờ, nghỉ phép, nghỉ ốm và các thông tin liên quan khác, tất cả đều có thể được xuất sang hệ thống tính lương.",
    },
    retailworkforce: {
      titlepage: "Doanh Nghiệp Bán Lẻ | Dịch vụ CheckID FacialSense",
      doanh3: "Doanh",
      nghiep3: "nghiệp",
      nghiep3content: "Nghiệp",
      headertitle: "Doanh Nghiệp Bán Lẻ",
      headertitle1: "Doanh nghiệp bán lẻ",
      doanh: "Doanh Nghiệp Bán",
      le: "Lẻ",
      doanhcontent1: "Doanh nghiệp bán",
      lecontent1: "lẻ",
      doanh1: "Doanh Nghiệp ",
      le1: "Bán Lẻ",
      doanh1content1: "Doanh nghiệp ",
      le1content1: "bán lẻ",
      header: " hệ thống giám sát thời gian và chấm công",
      theckeckid: "Hệ thống chấm công khuôn mặt CheckID FacialSense Bio",
      uses: " sử dụng ",
      biomatrici:
        "công nghệ nhận diện sinh trắc học khuôn mặt, vân tay và quét mống mắt",
      desbiomatric:
        " để giám sát, quản lý và đăng ký chấm công một cách hiệu quả, mà không cần phải sử dụng phần cứng chuyên dụng.",
      thisal: "Công nghệ sinh trắc học này được tích hợp trí tuệ nhân tạo giúp",
      retail: " doanh nghiệp bán lẻ ",
      tomain: "duy trì và nâng cao ",
      effect: "hiệu suất, năng suất và hiệu quả về chi phí ",
      workfore:
        "lực lượng lao động trong môi trường tốc độ cao tại cửa hàng. Mặc dù công nghệ sinh trắc học rất tiên tiến, nhưng báo cáo lại đơn giản, trực quan và linh hoạt theo yêu cầu kinh doanh của bạn.",
      theckeckidFacial:
        "Hệ thống chấm công CheckID FacialSense Bio là một giải pháp toàn diện được thiết kế để tích hợp liền mạch vào hoạt động nhân sự và tính lương của doanh nghiệp, đồng thời đảm bảo nhân viên được trả lương chính xác cho các ca làm việc của họ mà không cần đến thẻ từ, thẻ chấm công hay máy chấm công cồng kềnh.",
      key: "Các tính năng",
      cac: "Các tính",
      tinh: "năng",
      feature: " nổi bật",
      desfeature:
        "Hệ thống chấm công khuôn mặt CheckID FacialSense Bio có nhiều tính năng mạnh mẽ được thiết kế để tăng cường hiệu suất và độ chính xác trong việc giám sát thời gian và chấm công của nhân viên, bao gồm:",
      multiple: "Nhận diện nhiều khuôn mặt",
      multipledes:
        "Hệ thống chấm công văn phòng của chúng tôi có thể phát hiện và nhận diện các khuôn mặt của tất cả mọi người xuất hiện trong bức hình, giúp nhân viên không phải mất thời gian xếp hàng để đấu máy chấm công.",
      contactless: "Theo dõi chấm công không tiếp xúc",
      contactlessdes:
        "Không cần tiếp xúc vật lý khi người được nhận diện bằng khuôn mặt hoặc mống mắt.",
      liveness: "Phát hiện sự sống",
      livenessdes:
        "Trước khi bắt đầu nhận diện khuôn mặt, hệ thống có thể xác thực rằng việc ra/vào đang được thực hiện bởi một người thật.",
    },
    mobileandremote: {
      titlepage:
        "Nhân Viên Di Động và Làm Việc Từ Xa | Dịch vụ CheckID FacialSense",
      header: "Phần mềm",
      headernhan: "Phần mềm ",
      hadernhan1: "theo dõi Nhân viên di động",
      hadernhan2: " và làm việc từ xa",
      tuxa: " từ xa",
      tuxa2: "việc từ xa",
      xa: "và làm việc từ xa",
      mobile1: "di động và",
      and1: "và",
      lam: " làm việc từ xa",
      remote: "Từ xa",
      employee: "Nhân viên",
      headermobile: " theo dõi Nhân viên di động và làm việc từ xa",
      recognise:
        "Chúng tôi nhận ra rằng trong thế giới làm việc linh hoạt hiện nay, công ty của bạn có thể đối mặt với những thách thức mà trước đây chưa từng có, đặc biệt là trong việc theo dõi chấm công.",
      wewant:
        "Chúng tôi muốn đảm bảo rằng bạn sẽ không gặp vấn đề trong việc theo dõi chấm công một cách chính xác khi làm việc từ xa.",
      thecheckid:
        "Hệ thống theo dõi thời gian nhân viên làm việc từ xa CheckID Facialsense, được trang bị công nghệ nhận dạng sinh trắc học bao gồm nhận diện khuôn mặt, vân tay và quét mống mắt",
      toeffect:
        " để theo dõi, quản lý và đăng ký chấm công hiệu quả, ngay cả đối với nhân viên di động hoặc làm việc từ xa.",
      thisall: "Công nghệ sinh trắc học được hỗ trợ bởi AI này sẽ giúp",
      yourbussiness: " doanh nghiệp của bạn",
      and: "và các doanh nghiệp khác duy trì và nâng cao ",
      effect: "hiệu quả, năng suất cũng như tiết kiệm chi phí",
      workfore:
        "cho lực lượng lao động, bất chấp thách thức từ việc nhân viên làm việc bên ngoài văn phòng. Trong khi công nghệ sinh trắc học mang lại nhiều khả năng tiên tiến, thì báo cáo và giao diện người dùng lại đơn giản, trực quan và linh hoạt theo nhu cầu doanh nghiệp của bạn. Phần mềm theo dõi chấm công nhân viên từ xa bằng sinh trắc học của chúng tôi là một giải pháp được thiết kế để tích hợp liền mạch vào hoạt động quản lý nhân sự và tiền lương của doanh nghiệp bạn.",
      thesystem:
        "Hệ thống dễ sử dụng đối với nhân viên của bạn. Nếu họ có điện thoại, máy tính xách tay hoặc máy tính bảng, họ có thể đăng ký chấm công một cách dễ dàng, nhanh chóng và chính xác!",
      key: "Các tính năng",
      features: "Các tính",
      nang: "năng",
      keyfeatures: "Các tính năng",
      keyfeaturesdes:
        " của hệ thống theo dõi thời gian nhân viên làm việc từ xa",
      carefull:
        "Được thiết kế và xây dựng cẩn thận, phần mềm do đội ngũ tại CheckID FacialSense phát triển cung cấp nhiều tính năng mạnh mẽ, nhằm tăng cường hiệu suất kinh doanh của các công ty với lực lượng lao động di động, bao gồm:",
      nospecific: "Không yêu cầu phần cứng chuyên dụng cho người dùng*",
      nospecificdes:
        "Phần mềm theo dõi chấm công từ xa bằng sinh trắc học của chúng tôi có thể được nhân viên từ xa sử dụng thông qua điện thoại, máy tính bảng hoặc máy tính!",
      real: "Nhận diện khuôn mặt theo thời gian thực",
      realdes:
        "Hệ thống có thể phát hiện khuôn mặt của một người khi họ đi ngang qua mà không cần phải dừng lại chờ được chụp ảnh.",
      liveness: "Phát hiện sự sống",
      livenessdes:
        "Trước khi bắt đầu nhận diện khuôn mặt, hệ thống có thể xác thực rằng việc ra/vào đang được thực hiện bởi một người thật.",
      footer:
        "*Đối với nhận diện vân tay hoặc mống mắt, hệ thống yêu cầu một đầu đọc vân tay hoặc máy quét mống mắt bên ngoài, cả hai đều có thể được mua từ",
      whychoose:
        " chọn phần mềm chấm công bằng sinh trắc học của chúng tôi cho nhân viên làm việc từ xa?",
      whychossetitle: "Tại sao",
      why: "Tại sao",
      choose: "chọn",
      increasetem: "Tăng sự hài lòng của nhân viên",
      quickstart:
        "Không có gì làm giảm sự hài lòng của nhân viên hơn việc tiền lương không được thanh toán đúng. Tránh những vấn đề không cần thiết về lương nhờ hệ thống quản lý thời gian chính xác, đảm bảo mọi nhân viên đều được trả lương xứng đáng cho công việc của mình.",
    },
    student: {
      titlepage: "Điểm danh Học Sinh | Dịch vụ CheckID FacialSense",
      header: "Điểm danh Học Sinh",
      student: "Học Sinh",
      student1: "Chấm Công Học",
      sinh: "Sinh",
      attent: "Chấm Công",
      school: "Hệ thống điểm danh học sinh bằng ",
      schooldes1: "sinh trắc học cho trường ",
      hoc: "học",
      sinhtrac: "sinh trắc",
      hoccho: " học cho",
      truonghoc: " trường học",
      schooldes2: "sinh trắc học ",
      hoc1: "cho trường học",
      schooldes: " sinh trắc học cho trường học",
      thecheckid:
        "Hệ thống điểm danh học sinh sử dụng công nghệ nhận dạng khuôn mặt, vân tay hoặc mống mắt của CheckID FacialSense được thiết kế để hỗ trợ học sinh, giáo viên, thậm chí khi họ học từ xa.",
      wehave:
        "Chúng tôi đã xây dựng hệ thống điểm danh này để giúp các trường học và cơ sở giáo dục khác quản lý, ghi lại và phân tích sự hiện diện của học sinh và nhân viên bằng cách sử dụng công nghệ quét sinh trắc học AI của khuôn mặt, vân tay hoặc mống mắt.",
      with: "Vì sự chuyên cần gắn liền với hiệu quả giáo dục, chắc chắn bạn hiểu rõ việc cần phải có một hệ thống quản lý thời gian và điểm danh hiệu quả, chính xác cho cơ sở giáo dục của mình. Sau giai đoạn học tập trực tuyến trở nên phổ biến, việc trang bị một hệ thống điểm danh sinh trắc học cho trường học là vô cùng cần thiết — và hệ thống CheckID FacialSense của chúng tôi chắc chắn đáp ứng được yêu cầu đó.",
      thesystem:
        "Hệ thống này tích hợp đơn giản vào các hoạt động của bạn, đảm bảo học sinh của bạn được ghi nhận chính xác và đồng thời loại bỏ những rủi ro trong công tác hành chính của nhà trường. Trong khi công nghệ sinh trắc học mang đến những tính năng tiên tiến, thì giao diện báo cáo và quản lý của hệ thống lại rất đơn giản, trực quan và linh hoạt để phù hợp với yêu cầu hành chính của nhà trường.",
      key: "Tính năng chính",
      features: "Tính Năng",
      keyfeatures: "Tính Năng Chính",
      keyfeaturesdes: " của hệ thống chấm công học sinh của chúng tôi",
      ourteam:
        "Đội ngũ chuyên gia phát triển của chúng tôi đã xây dựng một hệ thống chấm công học sinh của trường học có nhiều tính năng mạnh mẽ nhằm giúp cơ sở giáo dục của bạn theo dõi và quản lý sự hiện diện một cách chính xác:",
      multiple: "Phát hiện nhiều khuôn mặt",
      multipledes:
        " Hệ thống điểm danh của chúng tôi có thể phát hiện và nhận dạng khuôn mặt của tất cả mọi người trong hình, giúp học sinh và nhân viên không phải lãng phí thời gian đứng xếp hàng chờ điểm danh.",
      realtime: "Nhận diện khuôn mặt theo thời gian thực",
      realtimedes:
        "Hệ thống có thể phát hiện khuôn mặt của một người khi họ đi ngang qua mà không cần phải dừng lại chờ được chụp ảnh.",
      tail: "Báo cáo linh hoạt",
      youcan:
        "Bạn có thể thiết lập các báo cáo CheckID FacialSense để linh hoạt với yêu cầu của bạn để theo dõi sự hiện diện của học sinh.",
      whychossedes:
        "Bạn có thể đã quen với nhiều hình thức điểm danh khác nhau, có hình thức hiện đại hơn, có hình thức truyền thống hơn, vì vậy việc chuyển sang một hệ thống sinh trắc học nghe có vẻ phức tạp. Thế nên chúng tôi đã đơn giản hóa để bạn dễ dàng hiểu những lý do tích cực tại sao một hệ thống điểm danh sinh trắc học cho trường học và các cơ sở giáo dục khác lại là lựa chọn phù hợp cho bạn:",
      whychosse:
        " hệ thống điểm danh của CheckID FacialSense cho cơ sở giáo dục của bạn?",
      whychossetitle: "Tại sao chọn",
      why: "Tại sao",
      choose: " chọn",
      encourage: "Khuyến khích chuyên cần",
      encouragedes:
        "Chuyên cần là yếu tố then chốt giúp đảm bảo học sinh, sinh viên nhận được nền giáo dục chất lượng cao. Một hệ thống chính xác nhưng dễ sử dụng đảm bảo không có yếu tố không cần thiết nào ảnh hưởng đến việc đến lớp.",
      streamline: "Quản lý hành chính hiệu quả",
      streamlinedes:
        "Báo cáo linh hoạt mà CheckID FacialSense cung cấp cho cơ sở giáo dục của bạn cho phép dễ dàng giám sát, phân tích và hiểu tình hình học tập của học sinh, sinh viên theo thời gian thực, giảm thiểu nhu cầu sử dụng sổ sách giấy tờ cồng kềnh và phức tạp.",
      reduce: "Giảm rủi ro sai sót",
      reducedes:
        "Giám sát thời gian và chuyên cần là một nhiệm vụ yêu cầu xử lý nhiều dữ liệu, dễ xảy ra sai sót do con người. Hệ thống điểm danh sinh trắc học CheckID FacialSense tự động giúp giảm thiểu rủi ro này, đồng thời đảm bảo việc ghi nhận và trình bày dữ liệu được khách quan và có trật tự.",
      reducetruancy: "Giảm tình trạng trốn học",
      reducetruancydes:
        "Thiết bị sinh trắc học sẽ loại bỏ tình trạng “điểm danh hộ”, khi một học sinh, sinh viên điểm danh thay cho bạn học khác. Bạn có thể yên tâm rằng người học thật sự có mặt trong những giờ học.",
      environ: "Thân thiện với môi trường",
      environdes:
        "Báo cáo bao gồm tóm tắt về tình hình chuyên cần, ngày nghỉ, nghỉ ốm và các dữ liệu liên quan khác.",
      comprehensive: "Báo cáo toàn diện",
      comprehensivedes:
        "Báo cáo bao gồm tổng kết về sự hiện diện của học sinh, số ngày nghỉ, nghỉ ốm và các dữ liệu khác liên quan.",
    },
    constructtion: {
      titlepage: "Công Trường Xây Dựng | Dịch vụ CheckID FacialSense",
      header: "Công trường xây dựng",
      construct: " xây dựng",
      header3: "Công trường xây ",
      dung: " dựng",
      site: " công trường",
      site1: "Công trường",
      headerdes: " Hệ thống giám sát thời gian và chấm công ",
      header1: "công trường xây dựng",
      thecheckid:
        "Hệ thống chấm công sinh trắc học của CheckID FacialSense sử dụng nhận dạng sinh trắc học từ",
      face: " khuôn mặt, vân tay và quét mống mắt",
      to: " để giám sát, quản lý và ghi nhận chấm công một cách hiệu quả trên quy mô lớn và linh hoạt, mà không cần thiết bị chuyên dụng.",
      accurate: "Báo cáo chính xác và hiệu quả về tình hình chuyên cần tại công trường là yếu tố then chốt cho sự thành công của các dự án xây dựng lớn. Lực lượng lao động xây dựng thường xuyên thay đổi và mang tính động cao, vốn nổi tiếng với các lỗi bảng lương, quản lý giờ làm thêm kém hiệu quả và tình trạng vắng mặt không kiểm soát do lịch trình và yêu cầu dự án liên tục thay đổi. Hệ thống chấm công sinh trắc học cũng ngăn chặn tình trạng gian lận hoặc ghi nhận sai lệch trong điểm danh, vốn thường xảy ra ở các hệ thống khác như thẻ từ, thẻ cảm ứng hoặc sổ điểm danh thủ công.",
      whilst:
        "Trong khi công nghệ sinh trắc học CheckID FacialSense tích hợp nhiều tính năng tiên tiến, thì giao diện người dùng và báo cáo lại đơn giản, trực quan và có thể tùy chỉnh linh hoạt theo yêu cầu doanh nghiệp của bạn. CheckID FacialSense là một giải pháp toàn diện, được thiết kế để tích hợp liền mạch vào quy trình nhân sự và tính lương tại công trường xây dựng, giúp dự án vận hành trôi chảy đồng thời đảm bảo người lao động từ xa được trả công một cách công bằng và chính xác.",
      keyfeatures: "Các tính năng",
      key: "năng",
      fearures: " Các tính",
      keyfeaturesdes:
        "Hệ thống chấm công sinh trắc học của CheckID FacialSense có nhiều tính năng mạnh mẽ được thiết kế để tăng cường hiệu suất và độ chính xác của việc giám sát thời gian và chấm công tại công trường xây dựng, bao gồm:",
      multiple: "Nhận diện nhiều khuôn mặt",
      multipledes:
        "Hệ thống chấm công sinh trắc học của chúng tôi có thể phát hiện và nhận dạng khuôn mặt của tất cả mọi người xuất hiện trong hình ảnh, nghĩa là người cần chấm công không cần phải mất thời gian xếp hàng chờ thực hiện thủ công.",
      location: "Theo dõi vị trí",
      locationdes:
        "Hệ thống chấm công của chúng tôi có thể theo dõi vị trí địa lý của địa điểm ra vào của một người.",
      liveness: "Phát hiện sự sống",
      livenessdes:
        "Trước khi bắt đầu nhận diện khuôn mặt, hệ thống có thể xác thực rằng việc ra/vào đang được thực hiện bởi một người thật.",
      hardhat: "Phát hiện khi đội mũ bảo hiểm",
      hardhatdes:
        "Đảm bảo nhân viên công trường của bạn tuân thủ các quy trình an toàn khi vào công trường bằng tính năng phát hiện mũ bảo hộ tự động.",
      remote: "Quản lý vị trí từ xa",
      remotedes:
        "Thời gian làm việc của nhân viên có thể được theo dõi và tính toán dễ dàng ngay cả khi họ làm việc từ xa. Người dùng có thể điểm danh một cách đơn giản với thiết bị di động, máy tính bảng hoặc máy tính cá nhân của họ.",
      identification: "Nhận diện khi đeo khẩu trang",
      identificationdes:
        "Hệ thống chấm công sinh trắc học của chúng tôi có khả năng nhận diện một người ngay cả khi họ đang đeo khẩu trang, đảm bảo việc nhận dạng an toàn và hợp vệ sinh.",
    },
    healthcare: {
      titlepage: "Chăm Sóc Sức Khoẻ | Dịch vụ CheckID FacialSense",
      header: "Chăm sóc sức khỏe",
      cham: "Chăm sóc sức",
      khoe: " khoẻ",
      chamsoc: "Chăm sóc",
      suckhoe: " sức khoẻ",
      headrdes: " bằng hệ thống sinh trắc học giám sát thời gian và hoạt động ra/vào",
      thecheckid:
        "Hệ thống sinh trắc học CheckID FacialSense sử dụng nhận dạng bằng ",
      face: " khuôn mặt, vân tay và quét mống mắt ",
      to: "để giám sát, quản lý và ghi nhận hoạt động ra/vào một cách hiệu quả trên quy mô lớn và linh hoạt, mà không cần thiết bị chuyên dụng.",
      ideal: "Lý tưởng cho các tổ chức chú trọng vệ sinh và sạch sẽ",
      notonly:
        "Các máy quét vân tay thông thường không chỉ tiềm ẩn nguy cơ lây nhiễm chéo, mà còn thường trở nên kém hiệu quả hoặc phản tác dụng trong môi trường mà nhân viên buộc phải sử dụng thiết bị bảo hộ cá nhân (PPE), chẳng hạn như găng tay dùng một lần.",
      checkidabbliti:
        "Khả năng quét và nhận diện thông qua khuôn mặt, vân tay hoặc mống mắt của CheckID FacialSense cho phép các cơ sở y tế giám sát điểm danh một cách vệ sinh và thực tế nhất theo yêu cầu cụ thể của họ. Trong khi công nghệ sinh trắc học có những tính năng tiên tiến, giao diện người dùng và báo cáo đơn giản và dễ hiểu, và đã được thiết kế như một giải pháp tích hợp mà bạn có thể dễ dàng kết nối vào hoạt động hiện tại của mình.",
      keyfeatures: "Các tính năng",
      key: "Tính",
      fearures: "Năng",
      keyfeaturesdes:
        "Hệ thống Điểm danh Sinh trắc học của CheckID FacialSense có nhiều tính năng mạnh mẽ được thiết kế để giám sát điểm danh một cách vệ sinh cho Tổ chức Y tế",
      contactless: "Theo dõi điểm danh không tiếp xúc",
      contactlessdes:
        "Không cần tiếp xúc vật lý khi người được nhận diện bằng khuôn mặt hoặc mống mắt.",
      liveness: "Quét nhiều khuôn mặt",
      livenessdes:
        "Hệ thống sinh trắc học của chúng tôi có thể phát hiện và nhận diện tất cả các khuôn mặt xuất hiện trong khung hình, giúp mọi người không phải tốn thời gian xếp hàng trước máy ghi nhận ra/vào.",
      mulbio: "Đa sinh trắc học",
      muldes:
        "Có sẵn 3 phương pháp sinh trắc học - khuôn mặt, vân tay và mống mắt.",
      multiple: "Quét nhiều khuôn mặt",
      multipledes:
        "Hệ thống chấm công văn phòng sinh trắc học của chúng tôi có thể phát hiện và nhận dạng khuôn mặt của tất cả mọi người xuất hiện trong hình ảnh, nghĩa là nhân viên của bạn không cần phải mất thời gian xếp hàng đợi để đến máy đánh giờ.",
    },
    service: {
      titlepage: "Dịch Vụ và Lưu Trú | Dịch vụ CheckID FacialSense",
      header: "Dịch Vụ Và Lưu Trú",
      header2: "Dịch Vụ Và",
      hopital: "khách sạn",
      hopitalup: "Lưu Trú",
      hopitaldes: "Phần mềm quản lý thời gian và điểm danh của dịch vụ  ",
      thecheckid:
        "CheckID FacialSense Bio Attendance sử dụng nhận dạng sinh trắc học của ",
      face: "khuôn mặt, vân tay và quét mống mắt ",
      to: "để giám sát, quản lý và đăng ký điểm danh một cách hiệu quả trên quy mô lớn và linh hoạt, mà không cần thiết bị chuyên dụng.",
      thisal:
        "Công nghệ sinh trắc học được hỗ trợ bởi trí tuệ nhân tạo này sẽ giúp ",
      retail: " doanh nghiệp trong ngành dịch vụ khách sạn",
      tomain: " duy trì và nâng cao ",
      effect: "một lực lượng lao động hiệu quả, năng suất và tiết kiệm chi phí ",
      workfore: "trong môi trường làm việc nhịp độ nhanh.",
      whilst: "Trong khi công nghệ sinh trắc học tiên tiến, thì hệ thống báo cáo:",
      simple: "Đơn giản",
      intuitive: "Dễ hiểu",
      cusztom: "Tuỳ chỉnh theo yêu cầu kinh doanh của bạn",
      our: "Phần mềm quản lý thời gian và điểm danh cho ngành dịch vụ khách sạn là một giải pháp đã được thiết kế để tích hợp liền mạch vào hoạt động quản lý nhân sự và thanh toán của doanh nghiệp của bạn. Đồng thời, hệ thống đảm bảo nhân viên của bạn được trả lương chính xác cho thời gian làm việc của họ.",
      simmular:
        "Đồng thời, nó sẽ đảm bảo nhân viên của bạn được bồi thường một cách chính xác cho thời gian họ đầu tư trong giờ làm việc.",
      contactwithstart: "Liên Hệ Với Chúng Tôi Để Bắt Đầu",

      keyfeatures: "Tính năng chính",
      key: "Tính",
      fearures: "Năng",
      keyfeaturesdes:
        "Hệ thống sinh trắc học của chúng tôi có nhiều tính năng mạnh mẽ được thiết kế để tăng cường hiệu suất của doanh nghiệp dịch vụ thông qua phần mềm quản lý thời gian và điểm danh hiệu quả. Các tính năng bao gồm:",
      multiple: "Quét nhiều khuôn mặt",
      multipledes:
        "Hệ thống chấm công văn phòng sinh trắc học của chúng tôi có thể phát hiện và nhận dạng khuôn mặt của tất cả mọi người xuất hiện trong hình ảnh, nghĩa là nhân viên của bạn không cần phải mất thời gian xếp hàng đợi để đến máy điểm danh.",
      nospecific: "Không yêu cầu phần cứng chuyên dụng cho người dùng*",
      nospecificdes:
        "Phần mềm theo dõi thời gian làm việc từ xa của chúng tôi có thể được sử dụng bởi nhân viên làm việc từ xa của bạn qua điện thoại, máy tính bảng hoặc máy tính!",
      liveness: "Phát hiện sự sống",
      livenessdes:
        "Trước khi bắt đầu nhận diện khuôn mặt, hệ thống có thể xác minh rằng việc điểm danh đang được thực hiện bởi một người thật.",
      location: "Theo dõi vị trí",
      locationdes:
        "Hệ thống có thể theo dõi vị trí địa lý nơi một người thực hiện việc điểm danh.",
      remote: "Quản lý vị trí từ xa",
      remotedes:
        "Thời gian làm việc của nhân viên có thể được theo dõi và tính toán dễ dàng ngay cả khi họ làm việc từ xa. Người dùng có thể điểm danh một cách đơn giản với thiết bị di động, máy tính bảng hoặc máy tính cá nhân của họ.",
      compre: "Báo cáo toàn diện",
      comperdes:
        "Báo cáo bao gồm tóm tắt về giờ làm việc, làm thêm giờ, nghỉ phép, nghỉ ốm và thông tin khác có thể xuất sang hệ thống thanh toán tiền lương.",
      footer:
        "*Đối với nhận dạng bằng vân tay hoặc mống mắt, hệ thống yêu cầu một bộ đọc vân tay hoặc máy quét mống mắt bên ngoài, cả hai đều có thể được mua từ",
      benefit: "Lợi ích",
      foryou: " cho doanh nghiệp dịch vụ của bạn?",
      employee: "Tăng sự hài lòng của nhân viên",
      employeedes:
        "Tránh những vấn đề không cần thiết về lương nhờ hệ thống quản lý thời gian chính xác, đảm bảo mọi nhân viên đều được trả lương xứng đáng cho công việc của mình.",
      streamline: "Tối ưu hóa quản lý nhân sự",
      streamlinedes:
        "Các báo cáo tùy chỉnh mà CheckID FacialSense cung cấp cho doanh nghiệp của bạn cho phép bạn dễ dàng giám sát, phân tích và hiểu rõ lực lượng lao động trong thời gian thực, giảm thiểu nhu cầu sử dụng những thủ tục giấy tờ rườm rà và gây nhầm lẫn.",
      reduce: "Giảm thiểu sai sót",
      reducedes:
        "Giám sát thời gian và chấm công là một công việc đòi hỏi dữ liệu lớn, dễ phát sinh lỗi do con người. Phần mềm chấm công văn phòng bằng sinh trắc học tự động giúp giảm thiểu rủi ro sai sót, đồng thời đảm bảo việc ghi nhận và trình bày dữ liệu một cách khách quan, có hệ thống.",
      increaseproductivity: "Tăng năng suất",
      increaseproductivitydes:
        "Máy quét sinh trắc học loại bỏ khả năng “chấm công hộ” - nhân viên này chấm công thay cho nhân viên khác. Vì vậy, bạn có thể yên tâm rằng lực lượng lao động của mình thực sự làm việc đủ số giờ mà họ báo cáo.",
      cost: "Hiệu quả chi phí",
      costdes:
        "Không chỉ giúp giảm chi phí lao động phát sinh do ghi chép không chính xác, mà tính năng nhận diện nhiều khuôn mặt cùng lúc còn có thể được sử dụng để giảm thời gian xếp hàng trước máy chấm công.",
      client: "Chứng thực từ ",
      compredes1:
        "Tất cả báo cáo toàn diện của bạn được tập trung tại một nơi, giúp tiết kiệm thời gian và chi phí cho việc quản lý các khía cạnh khác nhau của doanh nghiệp một cách riêng lẻ, đồng thời loại bỏ nỗi lo về báo cáo thiếu chính xác",
      testimonials: "khách hàng",
      items: {
        description:
          "“Chúng tôi đang sử dụng phần mềm này trong trường học để điểm danh nhân viên và nhận thấy nó rất hữu ích. Phần mềm này đăng ký đầy đủ thông tin chi tiết và dữ liệu sinh trắc học của toàn bộ nhân viên một cách nhanh chóng và chúng tôi đã có thể bắt đầu việc điểm danh ngay lập tức. Chúng tôi đã có thể theo dõi tình trạng vắng mặt của nhân viên cũng như những người đến muộn. Chúng tôi cũng có thể lấy báo cáo điểm danh hàng ngày một cách rất nhanh chóng mà không gặp bất kỳ khó khăn nào”",
        name: "Seema C.",
        position: "Giáo viên, Trường Trung học Red Roses",
      },
    },
    factory: {
      titlepage: "Nhà Máy và Kho Hàng | Dịch vụ CheckID FacialSense",
      header: "Hệ thống",
      headerder2: "Nhà máy và ",
      warehose: "kho hàng",
      headerdes:
        " giám sát thời gian và chấm công nhân viên nhà máy và kho hàng",
      thecheckid:
        "Hệ thống chấm công sinh trắc học CheckID FacialSense được các nhà tuyển dụng ưa chuộng nhờ khả năng duy trì và nâng cao hiệu quả, năng suất và tiết kiệm chi phí cho lực lượng lao động mà không cần đến phần cứng chuyên dụng.",
      checkid:
        "Hệ thống giám sát thời gian và chấm công của CheckID FacialSense sử dụng",
      biometric:
        " nhận dạng sinh trắc học khuôn mặt, dấu vân tay và quét mống mắt",
      thesystem:
        ". Hệ thống tích hợp đơn giản vào hoạt động Nhân sự và Lương của bạn, đảm bảo nhân viên của bạn được thanh toán chính xác và đồng thời loại bỏ các nút thắt trong quản lý lương của bạn.",
      whilst:
        " Trong khi công nghệ sinh trắc học mang lại những khả năng tiên tiến, báo cáo và",
      user: " giao diện người dùng đơn giản, trực quan và có thể tùy chỉnh",
      around:
        " xung quanh các yêu cầu kinh doanh của bạn, giúp bạn tận dụng những khả năng được cung cấp bởi trí tuệ nhân tạo cho doanh nghiệp của mình.",
      key: "Chìa khóa",
      keyfeatures: "Tính Năng Chính",
      fearures: "Tính Năng",
      keyfeaturesdes:
        "Hệ thống sinh trắc học của chúng tôi có nhiều tính năng mạnh mẽ được thiết kế để tăng cường hiệu suất dịch vụ của doanh nghiệp bạn thông qua phần mềm chấm công và giám sát thời gian hiệu quả. Các tính năng này bao gồm:",
      multiple: "Nhận diện nhiều khuôn mặt",
      multipledes:
        "Hệ thống chấm công của chúng tôi có thể nhận diện và nhận ra khuôn mặt của tất cả mọi người xuất hiện trong hình ảnh, điều này có nghĩa là nhân viên của bạn không cần phải lãng phí thời gian xếp hàng trước máy chấm công.",
      realtime: "Nhận diện khuôn mặt thời gian thực",
      realtimedes:
        "Hệ thống có thể nhận diện khuôn mặt của một người đi qua mà không cần dừng lại và đợi trong khi máy ảnh chụp ảnh.",
      turnkey: "Giải pháp tích hợp",
      turnkeydes:
        "Hệ thống chấm công sinh trắc học của CheckID FacialSense không yêu cầu phần cứng chuyên biệt*, và dễ dàng tích hợp với các nhà cung cấp lương hàng đầu để cho phép tích hợp liền mạch vào các thực hành kinh doanh thông thường của bạn.",
      footer:
        "*Đối với nhận dạng vân tay hoặc mống mắt, hệ thống yêu cầu một đầu đọc vân tay hoặc máy quét mống mắt bên ngoài, cả hai đều có thể được mua từ",
    },
    agriculture: {
      titlepage: "Nông Nghiệp | Dịch vụ CheckID FacialSense",
      header: "Nông nghiệp",
      header1: "nông nghiệp",
      nong: "Nông ",
      nong1: "nông",
      nghiep: "nghiệp",
      headerdes: " Hệ thống giám sát thời gian và chấm công trong ",
      thecheckid:
        "Hệ thống chấm công sinh trắc học CheckID FacialSense sử dụng nhận dạng sinh trắc học khuôn mặt, dấu vân tay và quét mống mắt để giám sát, quản lý và đăng ký chấm công một cách hiệu quả trên quy mô lớn và linh hoạt, mà không cần đến phần cứng chuyên biệt*.",
      accurate:
        "Báo cáo chính xác và hiệu quả tình hình chấm công tại hiện trường là yếu tố then chốt cho sự thành công của các dự án nông nghiệp quy mô lớn. Việc quản lý lực lượng lao động thay đổi liên tục và đầy biến động thường dẫn đến lỗi tính lương, quản lý làm thêm giờ kém hiệu quả và tình trạng vắng mặt không được kiểm soát do lịch trình và yêu cầu dự án liên tục thay đổi.",
      whilst:
        "Hệ thống CheckID FacialSense cũng ngăn chặn việc gian lận hoặc ghi nhận sai trong chấm công – vốn thường xảy ra ở các hệ thống khác như thẻ từ, thẻ chip hoặc sổ ghi danh.",
      fearuresdes:
        "Hệ thống sinh trắc học của chúng tôi có nhiều tính năng mạnh mẽ được thiết kế để tăng cường hiệu suất dịch vụ của doanh nghiệp bạn thông qua phần mềm chấm công và giám sát thời gian hiệu quả. Các tính năng này bao gồm:",
    },
    organizations: {
      titlepage: "Tổ Chức | Dịch vụ CheckID FacialSense",
      header: "Tổ Chức",
      headerdes: "Gặp người trong ",
      headernone: "tổ chức",
      usually:
        "Thông thường, trong một tổ chức, nhân viên sẽ phải gặp gỡ khách hàng. Tùy tình huống, cuộc gặp này có thể diễn ra trong khuôn viên văn phòng (phòng họp) hoặc tại một địa điểm khác. Trong trường hợp này, Hệ thống quản lý khách CheckID FacialSense có thể được sử dụng để thiết lập lịch họp tại địa điểm gặp. Khách có thể đặt lịch hẹn trong khung giờ này và nhân viên có thể hoàn thành tất cả các cuộc gặp với khách trong thời gian ngắn hơn.",
      thecheckid:
        "Hệ thống quản lý khách CheckID FacialSense có thể được cấu hình để gửi thông báo về các sự kiện khác nhau, cho cả nhân viên và khách. Ví dụ như thông báo cho nhân viên khi khách đã check-in với hệ thống. Sau đó, nhân viên cần đến địa điểm chỉ định để gặp khách.",
      when: "Khi sử dụng hệ thống quản lý khách CheckID FacialSense, nhân viên có thể gặp tất cả khách trong khoảng thời gian ngắn hơn, bởi vì việc gặp khách suốt cả ngày là không khả thi. Hệ thống này giúp nhân viên có thể dành thời gian cụ thể hoặc tận dụng thời gian trống để gặp khách. Đồng thời, khách cũng có thể đến gặp nhân viên mà không phải chờ đợi ở sảnh văn phòng. Như vậy, cả thời gian của nhân viên và khách đều không bị lãng phí.",
      usecase: "Ví dụ ",
      use: "Sử dụng",
      case: " trường hợp",
      usecaseheader: " tình huống sử dụng",
      employee: "Nhân viên: Xác định lịch trình thời gian",
      employeedes:
        "Nhân viên có thể quyết định khung giờ và địa điểm mà anh ấy/cô ấy muốn gặp khách. Sau đó từ hệ thống tạo một lịch trình theo thông tin này.",
      consumer: "Khách: Đặt lịch hẹn",
      consumerdes:
        "Khách có thể kiểm tra trực tuyến và đặt lịch hẹn để gặp nhân viên. Nếu cho phép lịch hẹn không đặt trước, khách có thể đặt lịch hẹn từ kiosk đăng ký.",
      fresh: "Khách: Check-in vào cuộc hẹn",
      freshdes:
        "Sau khi vào khuôn viên, khách có thể check-in vào hệ thống bằng ID lịch hẹn của họ. Hệ thống có thể được cấu hình để sử dụng ID được tạo tự động hoặc ID vật lý như thẻ căn cước công dân.",

      leads: "Tiến hành và hoàn tất buổi hẹn",
      leadsdes:
        "Nhân viên sẽ đến gặp khách khi nhận được thông báo. Sau buổi gặp, khách sẽ check-out tại địa điểm họp và nhân viên có thể đánh dấu lịch hẹn đã hoàn tất.",
      buytweak: "Người mua điều chỉnh nguồn cung cấp cơ hội của họ",
      buytweakdes:
        "Dữ liệu xếp loại cho phép người mua thấy chính xác chi phí cho mỗi bán hàng mỗi trang web họ nhận được cơ hội từ đó.",
      keyfeatures: "Tính năng chính",
      thecheckid2:
        "Hệ thống quản lý khách CheckID FacialSense có nhiều tính năng mạnh mẽ được thiết kế để cung cấp trải nghiệm thuận tiện và an toàn cho tất cả khách hàng trong khi giảm bớt sự phức tạp và gánh nặng quản lý khách trên nhân viên. Hệ thống của chúng tôi có nhiều tính năng bao gồm:",
      online: "Đặt hẹn trước trực tuyến",
      onlinedes:
        "Đặt lịch hẹn trực tuyến cho phép khách lên kế hoạch trước cho chuyến thăm và check-in/check-out dễ dàng, không rườm rà.",
      secure: " Đảm bảo tính an toàn",
      securedes:
        "Mã vạch, RFID, nhận diện khuôn mặt, vân tay và mống mắt giúp khách có thể check-in/check-out nhanh chóng, hiệu quả và an toàn trong các cuộc hẹn và tương tác.",
      feedback: "Đảm bảo vệ sinh",
      feedbackdes:
        "Công nghệ nhận diện không chạm bằng mã vạch, RFID, khuôn mặt và mống mắt giúp xác thực khách check-in/check-out mà không cần tiếp xúc trực tiếp.",
    },
    travel: {
      titlepage: "Du Lịch và Tham Quan | Dịch vụ CheckID FacialSense",
      header: "Du Lịch Và Tham Quan",
      headerTravel: "Du lịch và tham quan",
      after:
        "Sau đại dịch Covid-19, ngành du lịch mới bắt đầu phục hồi. Nhiều điểm du lịch trên thế giới đã nối lại hoạt động với nhiều biện pháp phòng ngừa sức khỏe và an toàn hơn. Việc tiếp nhận du khách từ nhiều quốc gia khác nhau và duy trì các tiêu chuẩn an toàn, sức khỏe là một trách nhiệm lớn đối với các điểm đến du lịch. Ở đây, chúng ta đang xét đến các công viên, viện bảo tàng, di tích lịch sử hay các điểm tham quan hấp dẫn cung cấp dịch vụ cho du khách.",
      asan: "Là một tổ chức, mỗi điểm tham quan du lịch cần có một số thông tin về khách tham quan. Trong bối cảnh hậu đại dịch hiện nay, tình trạng tiêm vaccine của khách là thông tin bắt buộc cần phải biết. Ngoài ra, tổ chức cũng cần biết tên, tuổi, ngôn ngữ… của du khách để cung cấp trải nghiệm phù hợp. Ví dụ, ngôn ngữ có thể được dùng để đưa ra hướng dẫn bằng chính ngôn ngữ của du khách. Một số nơi như viện bảo tàng cũng yêu cầu vé vào cửa, và du khách có thể muốn đặt vé cho chuyến tham quan vào một ngày trong tương lai.",
      with: "Với Hệ thống quản lý khách ra vào CheckID FacialSense, các điểm đến/tổ chức du lịch có thể thu thập những thông tin cần thiết từ du khách. Thông tin này có thể được tùy chỉnh theo yêu cầu. Với tính năng đặt vé trực tuyến, khách có thể đặt trước cho một ngày trong tương lai. Những người muốn tham quan trong cùng ngày có thể đăng ký tại kiosk, nơi sẽ thu thập thông tin tương tự như khi đăng ký trực tuyến. Ngoài ra, hệ thống còn hỗ trợ đặt vé, cấp vé và in vé ngay tại chỗ.",
      organiza: "Tổ chức: xác định khung giờ cho du khách",
      organizades:
        "Ban quản lý điểm đến/địa điểm du lịch có thể thiết lập các khung giờ mà du khách có thể tham quan. Đồng thời, vé cũng có thể được bán trực tiếp trên hệ thống.",
      visitor: "Khách: Check-in tại địa điểm",
      visitordes:
        "Du khách có thể kiểm tra trực tuyến và đặt lịch tham quan địa điểm. Nếu vé được phát hành tại cổng, việc này có thể được quản lý bằng một hoặc nhiều kiosk đặt tại lối vào.",
      visitorCheckin: "khách hàng: Check-in tại địa điểm",
      visitorCheckindes:
        "Sau khi vào địa điểm, dữ liệu của khách sẽ được sử dụng để cung cấp trải nghiệm tùy chỉnh. Ví dụ: thông báo một số khu vực hạn chế ra vào, sử dụng ngôn ngữ ưa thích của khách để cung cấp thông tin, hoặc dùng giọng nói phù hợp để thông báo cho trẻ em… là một số tình huống có thể áp dụng từ dữ liệu của khách.",
      ending: "Kết thúc chuyến tham quan và rời đi",
      endingdes:
        "Khi du khách hoàn tất việc khám phá địa điểm, họ có thể để lại phản hồi và rời đi.",
      keyfeaturesdes:
        "Hệ thống quản lý khách ra vào CheckID FacialSense có một số tính năng mạnh mẽ được thiết kế nhằm mang đến trải nghiệm tiện lợi và an toàn cho tất cả khách tham quan, đồng thời giảm bớt sự phức tạp trong quản lý khách và gánh nặng cho nhân viên. Hệ thống của chúng tôi bao gồm nhiều tính năng, trong đó có:",
      custom: "Đăng ký tùy chỉnh",
      customdes:
        "Đặt lịch trực tuyến và đặt lịch tại kiosk có thể được điều chỉnh để thu thập các thông tin khác nhau của khách tham quan tùy theo yêu cầu của khách hàng.",
      contact: "Truy cập không tiếp xúc",
      contactdes:
        "Không cần tiếp xúc vật lý khi người được nhận diện bằng khuôn mặt hoặc mống mắt.",
      issuing: "Phát hành vé",
      issuingdes:
        "Một vé hoặc thẻ vào cửa có thể được tạo và in ra. Nội dung của vé có thể được điều chỉnh theo nhu cầu của khách hàng.",
    },
    banking: {
      titlepage:
        "Ngân Hàng Hoặc Các Tổ Chức Tài Chính | Dịch vụ CheckID FacialSense",
      header: "Ngân Hàng Hoặc Các Tổ Chức Tài Chính",
      headernone: "Ngân hàng hoặc các tổ chức tài chính",
      finacial:
        "Các tổ chức tài chính như ngân hàng chủ trọng vấn đề an ninh. Những tổ chức này cần đảm bảo an toàn cho chính nhân viên, tài sản cũng như khách hàng đến giao dịch tại ngân hàng. Vì xác minh danh tính cá nhân là yếu tố quan trọng nhất, nên hầu hết các ngân hàng đều sử dụng sinh trắc học cho mục đích xác thực.",
      there:
        "Có một số khu vực trong ngân hàng mà khách hàng không được phép vào. Do ngân hàng thu thập nhiều dữ liệu cá nhân quan trọng từ khách hàng, nên việc bảo mật và đảm bảo an toàn tuyệt đối là điều bắt buộc.",
      checkid:
        'Hệ thống quản lý khách ra vào CheckID FacialSense cung cấp các phương thức sinh trắc học khuôn mặt, vân tay và quét mống mắt được hỗ trợ bởi công nghệ sinh trắc học SDK đáng tin cậy nhất. Ngoài ra, có thể bổ sung bước xác minh bổ sung để tăng cường bảo mật.',
      bank: "Ngân hàng: xác định giờ giao dịch cho khách hàng",
      bankdes:
        "Ban quản lý ngân hàng có thể xác định giờ giao dịch cho khách hàng. Mỗi mục đích giao dịch sẽ gắn với một địa điểm cụ thể. (Ví dụ: Yêu cầu vay vốn: tại phòng tín dụng).",
      custom: "Khách hàng: đặt lịch hẹn với ngân hàng",
      customdes:
        "Khách hàng sẽ được xác thực ngay khi đến. Ngân hàng có thể sử dụng dữ liệu sinh trắc học của khách hàng để nhận dạng và có thể bổ sung biện pháp an toàn bằng cách yêu cầu quét sổ tiết kiệm hoặc thẻ căn cước. Sau khi được xác minh, khách hàng được cho phép vào khu vực liên quan.",
      customvisit: "Khách hàng: đến ngân hàng",
      customvisitdes:
        "Khách hàng sẽ được xác thực khi đến. Ngân hàng có thể sử dụng sinh trắc học của khách hàng để nhận biết người. Như một biện pháp an toàn bổ sung, ngân hàng có thể yêu cầu quét sổ tiết kiệm hoặc thẻ ID. Sau khi xác minh, khách hàng được phép vào phần liên quan.",
      leave: "Rời khỏi ngân hàng",
      leavedes:
        "Sau khi hoàn tất giao dịch, khách hàng có thể để lại phản hồi tại thiết bị check-out và rời khỏi ngân hàng.",
      fearuresdes:
        "Hệ thống Quản lý khách ra vào CheckID FacialSense có một số tính năng mạnh mẽ được thiết kế để cung cấp trải nghiệm thuận tiện và an toàn cho tất cả du khách trong khi giảm bớt sự phức tạp và gánh nặng về quản lý khách hàng cho nhân viên. Hệ thống của chúng tôi có nhiều tính năng bao gồm:",
      biometric: "Nhận diện khách ra vào bằng sinh trắc học",
      biometricdes:
        "Nhận diện khuôn mặt, vân tay và quét mống mắt khi kiểm soát ra vào và quản lý khách.",
      contact: "Kiểm soát ra vào không tiếp xúc",
      contactdes:
        "Không cần tiếp xúc vật lý khi người dùng được nhận diện bằng khuôn mặt hoặc mống mắt. Các thiết bị kiểm soát ra vào chỉ hoạt động cho những khách đã được xác thực.",
      data: "Bảo mật dữ liệu",
      datades:
        "Các hoạt động liên quan đến khách được thực hiện bởi nhân sự được ủy quyền, do đó thông tin của khách và lịch sử ra vào được đảm bảo không bị truy cập trái phép.",
    },
    hotel: {
      titlepage: "Khách Sạn và Nhà Hàng | Dịch vụ CheckID FacialSense",
      header: "Khách Sạn Và Nhà Hàng",
      headernone: "Khách sạn và nhà hàng",
      inthe:
        "Trong ngành du lịch, các khách sạn và nhà hàng cũng cần nắm được một số thông tin về khách hàng của mình. Có nhiều lý do, nhưng quan trọng nhất là để đảm bảo an ninh và an toàn cho sức khỏe của tất cả khách lưu trú. Thẻ căn cước công dân đối với khách trong nước và hộ chiếu hoặc giấy tờ du lịch đối với khách quốc tế là những giấy tờ phổ biến nhất được yêu cầu khi đặt phòng khách sạn.",
      when: "Đối với nhà hàng, thông tin này có thể ít quan trọng hơn, nhưng việc biết trước sở thích ăn uống của khách hàng sẽ rất hữu ích. Khách hàng có thể gửi các lựa chọn thực đơn cho bữa sáng, bữa trưa, tiệc trà… ngay tại thời điểm đặt khách sạn hoặc nhà hàng, từ đó có thể tận hưởng thời gian của mình mà không cần gọi dịch vụ phòng thường xuyên.",
      for: "Đối với các khách hàng quen thuộc, việc lưu giữ thông tin các lần họ từng sử dụng dịch vụ trong hệ thống sẽ là một lợi thế, đồng thời khách sạn/nhà hàng có thể đưa ra mức giá ưu đãi đặc biệt cho những khách hàng này.",
      organiza: "Tổ chức: định nghĩa các khoảng thời gian cho khách du lịch",
      organizades:
        "Quản lý tại điểm đến/địa điểm du lịch có thể định nghĩa các khoảng thời gian mà khách du lịch có thể tham quan và chiêm ngưỡng. Cùng lúc, vé có thể được bán từ hệ thống.",
      visitor: "Khách tham quan: đặt lịch hẹn",
      visitordes:
        "Khách tham quan có thể kiểm tra trực tuyến và đặt lịch hẹn để tham quan địa điểm. Nếu vé được phát từ cổng, nó có thể được quản lý bằng một thiết bị kiểm soát ở lối vào.",
      visitorCheckin: "Khách tham quan: Check-in tại địa điểm",
      visitorCheckindes:
        "Sau khi vào địa điểm, dữ liệu của khách truy cập sẽ được sử dụng để cung cấp trải nghiệm tùy chỉnh bên trong cơ sở. Quyền truy cập vào một số phần nhất định có thể bị hạn chế, tùy chọn ngôn ngữ của khách truy cập có thể được sử dụng để cung cấp thông tin chi tiết bằng ngôn ngữ của họ, sử dụng giọng điệu khác cho trẻ em,...",
      ending: "Kết thúc việc thăm và rời đi",
      endingdes:
        "Khi khách tham quan kết thúc việc khám phá địa điểm, họ có thể để lại phản hồi và rời đi.",
      bank: "Ngân hàng: định nghĩa giờ làm việc cho khách hàng",
      bankdes:
        "Quản lý ngân hàng có thể định nghĩa giờ làm việc cho khách hàng. Mỗi mục đích sẽ có một địa điểm đi kèm. (Ví dụ: Yêu cầu vay: tại phòng tín dụng)",
      customer: "Khách hàng: đặt lịch hẹn với ngân hàng",
      customerdes:
        "Khách hàng có thể đặt yêu cầu bằng cách giải thích nhu cầu của họ. Một nhân viên từ ngân hàng có thể kiểm tra yêu cầu và có thể chấp nhận / chỉnh sửa hoặc từ chối yêu cầu.",
      customvisit: "Khách hàng: thăm ngân hàng",
      customvisitdes:
        "Khách hàng sẽ được xác thực khi đến. Ngân hàng có thể sử dụng dấu vân tay của khách hàng để xác định người đó. Là biện pháp an toàn bổ sung, ngân hàng có thể yêu cầu quét sổ tiết kiệm hoặc thẻ căn cước. Sau khi xác minh, khách hàng được phép vào phần liên quan.",
      leaving: "Rời khỏi khu vực",
      leavingdes:
        "Sau khi hoàn thành công việc được yêu cầu từ ngân hàng, khách hàng có thể để lại phản hồi trong thiết bị check-out và rời khỏi khu vực.",
      hotel: "Khách sạn/nhà hàng: chấp nhận đặt phòng/bàn",
      hoteldes:
        "Nhân viên vận hành khách sạn có thể xác định số lượng đặt chỗ dựa trên tình trạng còn trống. Khách có thể đặt chỗ bất kỳ lúc nào nên không cần phải bước chấp nhận/từ chối đặt phòng truyền thống. Khi không còn phòng/bàn trống, khách sẽ không thể đặt thêm.",
      guest: "Khách: thực hiện đặt chỗ",
      guestdes:
        "Khách có thể đặt chỗ trực tuyến hoặc sử dụng kiosk đặt chỗ.",
      guestCheck: "Khách: Check-in vào khu vực",
      guestCheckdes:
        "Khi khách check-in vào khu vực, quầy lễ tân sẽ nhận được thông báo và có thể tiến hành các bước tiếp theo, chẳng hạn như phục vụ đồ uống chào mừng.",
      endingStay: "Kết thúc và check-out",
      endingStaydes:
        "Cuối cùng, khách sẽ thực hiện check-out trên hệ thống. Ngoài ra, hệ thống có thể tính chi phí và xuất hóa đơn gửi khách hàng.",
      fearuresdes:
        "Hệ thống Quản lý khách hàng CheckID FacialSense có nhiều tính năng mạnh mẽ được thiết kế để cung cấp trải nghiệm thuận tiện và an toàn cho tất cả khách hàng trong khi giảm bớt sự phức tạp trong việc quản lý khách hàng và gánh nặng cho nhân viên. Hệ thống của chúng tôi có nhiều tính năng bao gồm:",
      bio: "Nhận dạng khách hàng theo vân tay",
      biodes:
        "Nhận dạng khuôn mặt, dấu vân tay và mống mắt của khách hàng trong kiểm soát ra vào và quản lý khách hàng",
      automated: "Kiểm soát ra vào tự động",
      automateddes:
        "Các cổng cho phép khách ra vào sẽ được kiểm soát bằng các thiết bị quét sinh trắc học.",
      custom: "Đăng ký có thể tùy chỉnh",
      customdes:
        "Đặt chỗ trực tuyến và đặt chỗ qua kiosk có thể được tùy chỉnh để thu thập các thông tin khác nhau của khách ra vào theo yêu cầu của khách sạn/nhà hàng.",
    },
    consultation: {
      titlepage: "Dịch Vụ Tư Vấn | Dịch vụ CheckID FacialSense",
      header: "Dịch Vụ Tư Vấn",
      headernone: "Dịch vụ tư vấn",
      consultation:
        "Dịch vụ tư vấn là một cách tuyệt vời để nhận lời khuyên từ chuyên gia trong lĩnh vực. Các dịch vụ này rất đa dạng, bao gồm y tế, kỹ thuật, tư vấn cá nhân, v.v. Chuyên gia có thể trực tiếp cung cấp dịch vụ tư vấn, hoặc một tổ chức trung gian sẽ thay mặt cho chuyên gia để quản lý việc đặt lịch hẹn. Trong lĩnh vực tư vấn, khách hàng có thể cần chia sẻ thông tin cá nhân và riêng tư của mình với chuyên gia. Trong tư vấn y tế, bác sĩ có thể cần biết lịch sử bệnh án và đây là thông tin cần được bảo mật. Vì vậy, tổ chức quản lý dữ liệu khách hàng thay mặt cho chuyên gia có trách nhiệm đảm bảo an toàn cho những dữ liệu này. Ngoài ra, chuyên gia có thể cần tham khảo thông tin và ghi chú từ các buổi tư vấn trước đó.",
      with: 'Với Hệ thống quản lý khách ra vào CheckID FacialSense, khi sử dụng kịch bản "Tư vấn", một tổ chức có thể quản lý lịch trình cho việc tư vấn. Việc xác định khung giờ tư vấn, lưu giữ ghi chú trong buổi làm việc, tham khảo dữ liệu tư vấn trước đó đều có thể thực hiện thông qua hệ thống.',
      institution: "Tổ chức: Tạo lịch tư vấn thay cho chuyên gia",
      institutiondes:
        "Tổ chức có thể tạo ra lịch tư vấn riêng cho từng chuyên gia dựa trên lịch trình của họ và phân bổ địa điểm tư vấn (phòng tư vấn). Ngoài ra, thời lượng mỗi buổi tư vấn và chi phí tư vấn cũng có thể được ghi rõ trong lịch.",
      guestreserve: "Khách hàng: Đặt lịch hẹn với chuyên gia",
      guestreservedes:
        "Khách hàng có thể đặt lịch trực tuyến hoặc qua kiosk nếu có. Khi số lượng lịch hẹn trong ngày đã đầy, khách hàng sẽ không thể đặt cho cùng ngày đó nữa.",
      guestcheck: "Khách hàng: Check-in tại tổ chức",
      guestcheckdes:
        "Khách hàng sẽ xuất trình vé đặt lịch tại quầy lễ tân để xác nhận check-in và thanh toán chi phí tư vấn (nếu có).",
      ending: "Kết thúc buổi tư vấn",
      endingdes:
        "Sau buổi tư vấn, khách hàng có thể check-out từ hệ thống. Nếu có các hoạt động khác như lấy thuốc theo toa, khách hàng có thể sử dụng vé đặt lịch tại nhà thuốc.",
      fearuresdes:
        "Hệ thống Quản lý khách hàng CheckID FacialSense có nhiều tính năng mạnh mẽ được thiết kế để cung cấp trải nghiệm thuận tiện và an toàn cho tất cả khách hàng trong khi giảm bớt sự phức tạp trong việc quản lý khách hàng và gánh nặng cho nhân viên. Hệ thống của chúng tôi có nhiều tính năng bao gồm:",
      electronic: "Thẻ điện tử",
      electronicdes:
        "Tự động tạo thẻ hoặc sử dụng thẻ điện tử xác định trước như mã vạch, RFID, biển số xe… để làm thẻ khách.",
      contact: "Theo dõi ra vào không tiếp xúc",
      contactdes:
        "Không cần tiếp xúc vật lý khi người dùng được nhận diện bằng sinh trắc học như khuôn mặt. Đây là tính năng quan trọng nhất đối với các cơ sở y tế.",
      customer: "Ghi chú lượt ra vào có thể được tùy chỉnh",
      customerdes:
        "Ghi chú lượt ra vào có thể được tùy chỉnh bằng biểu mẫu và tệp đính kèm để tạo nhật ký chi tiết.",
    },
    building: {
      titlepage: "Tòa Nhà và Căn Hộ | Dịch vụ CheckID FacialSense",
      header: "Tòa Nhà Và Căn Hộ",
      headerdes: "Hệ thống Quản lý Khách ra vào cho",
      ensure:
        "Đảm bảo rằng chung cư hoặc bất kỳ tòa nhà nào cũng có khả năng cấp quyền ra vào cho các lượt thăm viếng một cách dễ dàng và hiệu quả nhờ hệ thống quản lý khách CheckID FacialSense dành cho căn hộ.",
      sercuity:
        "An ninh và quyền riêng tư là yếu tố bắt buộc đối với cư dân và người sử dụng trong khuôn viên này. Họ có thể yên tâm rằng khách đến thăm chỉ được phép vào khu phức hợp nếu tuân thủ phần mềm quản lý khách bằng sinh trắc học. Quyền ra vào của khách có thể chỉ được cấp cho những khu vực nhất định nếu được chọn trước, vì vậy nếu ai đó cố gắng vào khu vực không được phép, hệ thống sẽ từ chối và sự cố này sẽ được báo cáo cho nhân viên an ninh.",
      using:
        "Việc sử dụng hệ thống quản lý khách CheckID FacialSense cho căn hộ sẽ thay đổi và tối ưu hóa quy trình cho phép khách như nhân viên vệ sinh hoặc kỹ thuật bảo trì ra vào khu phức hợp mà không gây gián đoạn cho cư dân, đồng thời giúp họ có thêm thời gian thực hiện công việc của mình.",
      quickdes:
        "Các hướng dẫn từng bước được cung cấp để bạn bắt đầu với hệ thống quản lý khách CheckID FacialSense dành cho căn hộ. Cả hệ thống dựa trên Đám mây Tại cơ sở đều được thiết kế để dễ sử dụng cho cả tổ chức của bạn và khách đến thăm. Chỉ cần đăng ký, tải xuống và cấu hình hệ thống theo yêu cầu của bạn, xác định lịch thăm viếng và cho phép khách đặt lịch hẹn trực tuyến hoặc thông qua kiosk đăng ký.",
      create: "Tạo lịch cho khách đến thăm",
      createdes:
        "Ban quản lý chung cư có thể tạo lịch này để cho phép khách gửi yêu cầu ra vào. Khi nhận được yêu cầu, ban quản lý sẽ xác nhận với bên liên quan (chủ hộ) và phê duyệt lịch hẹn ra vào.",
      guest: "Khách: Yêu cầu thăm",
      guestdes:
        "Khách có thể đặt lịch hẹn trực tuyến hoặc qua kiosk tại khu vực. Khi yêu cầu được gửi, ban quản lý sẽ xác nhận với chủ hộ và duyệt lịch hẹn. Sau đó, khách sẽ nhận được thẻ ra vào tạm thời.",
      guestCheck: "Khách: Check-in tại tòa nhà",
      guestCheckdes:
        "Tại cổng bảo vệ, khách sẽ check-in và xuất trình thẻ tạm thời cho bảo vệ. Bảo vệ sẽ cấp một thẻ khách vãng lai để sử dụng tại các cửa ra vào.",
      leaving: "Rời khỏi tòa nhà",
      leavingdes:
        "Khi rời đi, khách có thể trả lại thẻ được bảo vệ cấp, đồng thời hệ thống sẽ ghi nhận việc check-out và đánh dấu lịch hẹn đã hoàn tất.",
      keyfeatures:
        "Hệ thống quản lý khách CheckID FacialSense dành cho căn hộ có nhiều tính năng mạnh mẽ được thiết kế để mang lại trải nghiệm tiện lợi và an toàn cho tất cả khách đến, đồng thời giảm thiểu sự phức tạp trong quản lý khách và gánh nặng cho nhân viên. Dưới đây là một số tính năng chính mà bạn sẽ trải nghiệm khi tích hợp hệ thống của chúng tôi:",
      automated: "Kiểm soát ra vào tự động",
      automateddes:
        "Các cổng và cửa được phân quyền cho khách hoặc hạn chế đối với khách sẽ được kiểm soát thông qua các thiết bị chấm công/kiểm soát ra vào.",
      secure: "Xác nhận ra vào an toàn",
      securedes:
        "Công nghệ nhận diện khách bằng Mã vạch (Barcode), RFID, Khuôn mặt, Vân tay và Mống mắt mang đến khả năng truy cập nhanh chóng, hiệu quả và an toàn cho các cuộc hẹn và tương tác của khách.",
      realtime: "Phân tích khách theo thời gian thực",
      realtimedes:
        "Các thiết bị kiểm soát ra vào ghi nhận dữ liệu khách và các trường hợp bị từ chối vào hệ thống.",
      whycheckid:
        "Tại sao hệ thống quản lý khách của CheckID FacialSense cho ",
      apartment: "căn hộ",
      willmake: " sẽ tạo ra sự khác biệt ",
      increase: "Tăng sự hài lòng của người dùng",
      increasedes:
        "Cách tốt nhất để làm hài lòng khách đến thăm là giúp chuyến thăm của họ thuận tiện và suôn sẻ hơn. Giảm thời gian xếp hàng và khâu soát ra vào nhanh hơn nhằm mang lại trải nghiệm tối ưu trong khuôn viên.",
      see: "Kiểm tra được người trong khuôn viên",
      seedes:
        "Hệ thống quản lý khách CheckID FacialSense dành cho căn hộ cho phép quản trị viên xem có bao nhiêu khách đang ở bên trong, theo từng vị trí và lập kế hoạch phù hợp để tránh tình trạng quá đông đúc. Để thuận tiện hơn, các báo cáo tùy chỉnh có thể được lên lịch gửi qua email.",
      automatedaccess: "Kiểm soát ra vào tự động",
      automatedaccessdes:
        "Thiết bị kiểm soát sẽ nhận dạng khách và thực thi việc kiểm soát ra vào. Quản trị viên có thể xem nhật ký truy cập của khách và những ai bị từ chối nhờ vào hình ảnh khuôn mặt đã lưu trữ. Các hành động tùy chỉnh có thể được cấu hình để thực hiện các chức năng bổ sung, chẳng hạn như mở cửa hoặc kích hoạt báo động.",
      data: "Dữ liệu và quyền riêng tư",
      datades:
        "Chỉ có nhân sự được ủy quyền trong tổ chức mới có thể truy cập thông tin của khách, vì vậy tất cả thông tin cá nhân và sinh trắc học sẽ được bảo mật khỏi những kẻ xâm nhập.",
      quickly: " Đặt lịch nhanh chóng và đơn giản",
      quicklydes:
        "Đặt lịch hẹn chắc chắn phải là một quy trình đơn giản. Chúng tôi đã tối ưu hóa điều này bằng cách giới thiệu hình thức đặt lịch trực tuyến và kiosk dành cho khách đến trực tiếp.",
      customizable: "Giao diện khách hàng có thể tùy chỉnh",
      customizabledes:
        "Hệ thống quản lý khách CheckID FacialSense dành cho căn hộ bao gồm các kịch bản được định sẵn cho nhiều trường hợp sử dụng khác nhau. Nếu bạn cần thay đổi trong việc thu thập thông tin khách hoặc muốn thêm logo tùy chỉnh…, vui lòng liên hệ với chúng tôi để được tùy chỉnh theo yêu cầu.",
      key: " của hệ thống quản lý khách cho căn hộ",
      headerdesapr: "Các tính năng",
    },
    customer: {
      titlepage: "Hỗ Trợ Khách Hàng | Dịch vụ CheckID FacialSense",
      header: "Hỗ Trợ Khách Hàng",
      headernone: "Hỗ trợ khách hàng",
      allbuissess:
        "Tất cả doanh nghiệp đều cần có một bộ phận chuyên trách chăm sóc khách hàng riêng biệt. Khách hàng đến vì nhiều lý do khác nhau, chẳng hạn như thanh toán hóa đơn, sửa chữa đồ đạc, khiếu nại, dịch vụ sau bán hàng,... Nhân viên lễ tân sẽ hỏi vấn đề của khách hàng và dựa trên thông tin được cung cấp, khách hàng sẽ được cấp một vé để gặp nhân viên hỗ trợ.",
      using:
        "Với hệ thống quản lý khách CheckID FacialSense, nhân viên lễ tân có thể tạo lịch hẹn cho các nhân viên hỗ trợ khách hàng khác nhau. Tại mỗi bàn làm việc của nhân viên hỗ trợ sẽ có màn hình hiển thị phía trên để hiển thị số lượt hẹn hiện tại và các lượt hẹn tiếp theo. Khách hàng có thể chờ trong hàng và gặp nhân viên khi đến lượt.",
      customer:
        "Nhân viên hỗ trợ khách hàng cũng có thiết bị chấm công để xác nhận hoàn tất lịch hẹn sau khi xử lý vấn đề của khách hàng.",
      create: "Tạo lịch trình cho từng nhân viên hỗ trợ",
      createdes:
        "Trong một trung tâm hỗ trợ khách hàng, các nhân viên khác nhau sẽ chia sẻ nhóm khách hàng, và một số nhân viên là chuyên gia trong những lĩnh vực nhất định. Mỗi nhân viên xử lý khách hàng một cách độc lập.",
      resception: "Lễ tân: tiếp nhận yêu cầu khách hàng và cấp vé",
      resceptiondes:
        "Lễ tân là người nắm rõ năng lực của từng nhân viên hỗ trợ. Dựa trên tình trạng sẵn sàng của các nhân viên hỗ trợ, lễ tân sẽ tạo lịch hẹn và cấp vé cho khách hàng. Vé sẽ có số quầy để khách hàng có thể chờ đến lượt mình. ",
      address: "Giải quyết vấn đề và kết thúc buổi hẹn",
      addressdes:
        "Nhân viên hỗ trợ sẽ tiếp nhận vấn đề của khách hàng và hoàn tất buổi hẹn. Cuối buổi hẹn, nhân viên có thể yêu cầu khách hàng đưa phản hồi tại màn hình check-out.",
      featuredes:
        " Hệ thống quản lý CheckID FacialSense có nhiều tính năng mạnh mẽ, được thiết kế nhằm mang đến trải nghiệm thuận tiện và an toàn cho tất cả khách cần nhân viên hỗ trợ, đồng thời giảm bớt sự phức tạp trong quản lý khách và gánh nặng cho nhân viên. Hệ thống bao gồm nhiều tính năng nổi bật như:",
      auto: "Tự động tạo thẻ",
      autodes:
        "Tự động tạo thẻ ra vào hoặc sử dụng thẻ điện tử định danh như mã vạch, RFID, biển số xe để cấp cho khách làm thẻ ra vào.",
      overhead: "Màn hình hiển thị phía trên",
      overheaddes:
        "Thiết bị khách của hệ thống quản lý ra vào có thể được cấu hình để hiển thị phía trên, cho phép hiển thị lượt hẹn hiện tại và các lượt hẹn tiếp theo.",
      feedback: "Phản hồi khi check-out",
      feedbackdes:
        "Khách hàng có thể đánh giá trải nghiệm của mình khi check-out. Thông tin này sẽ hữu ích trong việc đo lường chất lượng dịch vụ hỗ trợ của nhân viên.",
    },
    entertainment: {
      titlepage: "Giải Trí | Dịch vụ CheckID FacialSense",
      header: "Giải Trí",
      headerdes: " quản lý khách ra vào qua Kiosk",
      system: "Giải pháp hệ thống",
      here: "Tại CheckID FacialSense, đội ngũ chuyên gia giàu kinh nghiệm trong lĩnh vực giám sát điểm danh của chúng tôi đã phát triển một hệ thống quản lý khách ra vào bằng kiosk, hoàn hảo để tích hợp tại các địa điểm giải trí.",
      entertainment:
        "Các điểm đến vui chơi như rạp chiếu phim, công viên giải trí, lễ hội và công viên công cộng thường quá tải vào các ngày lễ và cuối tuần, trong khi khách tham quan thì muốn tận hưởng trọn vẹn địa điểm mà họ lựa chọn và dành nhiều thời gian ở đây nhất có thể. Giải pháp quản lý khách ra vào bằng kiosk dễ sử dụng sẽ giúp hiện thực hóa điều đó, mang đến cho khách trải nghiệm vào cổng nhanh chóng, tiện lợi và an toàn.",
      with: "Với CheckID FacialSense, hệ thống của chúng tôi cung cấp các biểu mẫu đơn giản chỉ yêu cầu lượng thông tin tối thiểu từ khách tham quan, chẳng hạn như họ tên và tuổi, sau đó tiến hành mua vé. Khách có thể đặt vé trực tuyến và in vé, hoặc đặt trực tiếp tại kiosk ở cổng. Việc in vé có thể được cấu hình thông qua máy in ngoài kết nối với kiosk. Tại cổng vào, khách quét vé bằng thiết bị. Nếu vé đã được đánh dấu là đã thanh toán, khách sẽ được phép vào khu vực giải trí.",
      control: " Quản lý khách ra vào một cách ",
      simplicity: "đơn giản",
      management: "Quản lý: Lập lịch cho từng sự kiện/địa điểm",
      managementdes:
        "Ban quản lý cần tạo nhiều lịch trình cho từng sự kiện hoặc địa điểm để khách có thể tự đặt chỗ.",
      visitor: "Khách: Chọn sự kiện/địa điểm và tiến hành đặt vé",
      visitordes:
        "Khách có thể đặt vé trực tuyến, hoặc sử dụng kiosk tại cơ sở. Nếu khu giải trí có nhiều khu vực, hệ thống kiosk có thể được cấu hình để phân loại vé cho từng mục đích cụ thể. Sau khi đặt, vé sẽ được tạo và yêu cầu thanh toán. Nhân viên thu ngân sẽ đánh dấu vé đã thanh toán (đặt trạng thái “hoàn tất”).",
      it: "Tận hưởng trải nghiệm giải trí!",
      itdes:
        "Sau khi vé được xác thực hợp lệ để vào khu vực (ví dụ: đã hoàn tất thanh toán). Khách có thể check-out bất kỳ lúc nào.",
      quickstartheader:
        "Hướng dẫn bắt đầu nhanh chóng cho hệ thống quản lý khách hàng qua Kiosk của CheckID FacialSense",
      quickstartdes:
        "Các hướng dẫn từng bước được cung cấp để bạn bắt đầu với các giải pháp hệ thống của chúng tôi, giúp bạn không mất thời gian khi triển khai và nhận được mọi mẹo hữu ích mà bạn có thể cần.",
      fearuresdes:
        "Hệ thống quản lý khách của CheckID FacialSense có nhiều tính năng mạnh mẽ được thiết kế để cung cấp trải nghiệm thuận tiện và an toàn cho tất cả khách hàng trong khi giảm bớt sự phức tạp trong việc quản lý khách và gánh nặng cho nhân viên. Hệ thống của chúng tôi có nhiều tính năng bao gồm:",
      auto: "Vé ra vào tự động",
      autodes:
        "Hệ thống cho phép tạo vé tự động hoặc sử dụng vé điện tử xác định như mã vạch, RFID, biển số xe để làm vé khách.",
      overhead: "Màn hình hiển thị phía trên",
      overheaddes:
        "Thiết bị quản lý khách có thể cấu hình như một màn hình hiển thị phía trên, cho thấy lịch hẹn hiện tại và tiếp theo.",
      feedback: "Phản hồi khi check-out",
      feedbackdes:
        "Khách hàng có thể đánh giá trải nghiệm của họ khi check-out. Thông tin như vậy sẽ hữu ích để đo lường chất lượng dịch vụ của nhân viên.",
      whychossedes: " hệ thống quản lý khách ra v qua Kiosk của chúng tôi?",
      increase: "Nâng cao sự hài lòng của khách",
      increasedes:
        "Làm khách hàng hài lòng bằng cách đơn giản hóa quá trình. Việc giảm thời gian xếp hàng chờ cho phép khách có nhiều thời gian tận hưởng dịch vụ, từ đó nâng cao trải nghiệm tại địa điểm.",
      see: "Kiểm tra được người trong khuôn viên",
      seedes:
        "Hệ thống quản lý khách CheckID FacialSense qua kiosk cho phép quản trị viên xem có bao nhiêu khách đang ở bên trong, theo từng vị trí và lập kế hoạch phù hợp để tránh tình trạng quá đông đúc. Để thuận tiện hơn, các báo cáo tùy chỉnh có thể được lên lịch gửi qua email.",
      automatedaccess: "Kiểm soát ra vào tự động",
      automatedaccessdes:
        "Thiết bị kiểm soát sẽ nhận dạng khách và thực thi việc kiểm soát ra vào. Quản trị viên có thể xem nhật ký truy cập của khách và những ai bị từ chối nhờ vào hình ảnh khuôn mặt đã lưu trữ. Các hành động tùy chỉnh có thể được cấu hình để thực hiện các chức năng bổ sung, chẳng hạn như mở cửa hoặc kích hoạt báo động.",
      data: "Dữ liệu và quyền riêng tư",
      datades:
        "Chỉ có nhân sự được ủy quyền trong tổ chức mới có thể truy cập thông tin của khách, vì vậy tất cả thông tin cá nhân và sinh trắc học sẽ được bảo mật khỏi những kẻ xâm nhập.",
      quickly: "Đặt lịch nhanh chóng và đơn giản",
      quicklydes:
        "Đặt lịch hẹn chắc chắn phải là một quy trình đơn giản. Chúng tôi đã tối ưu hóa điều này bằng cách giới thiệu hình thức đặt lịch trực tuyến và kiosk dành cho khách đến trực tiếp.",
      customizable: "Giao diện khách hàng có thể tùy chỉnh",
      customizabledes:
        "Hệ thống quản lý khách CheckID FacialSense qua kiosk bao gồm các kịch bản được định sẵn cho nhiều trường hợp sử dụng khác nhau. Nếu bạn cần thay đổi trong việc thu thập thông tin khách hoặc muốn thêm logo tùy chỉnh…, vui lòng liên hệ với chúng tôi để được tùy chỉnh theo yêu cầu.",
    },
    school: {
      titlepage: "Trường Học và Các Khuôn Viên| Dịch vụ CheckID FacialSense",
      header: "Trường Học Và Các Khuôn Viên",
      visitor: "Hệ thống quản lý khách ra vào cho ",
      school: " trường học",
      our: "Hệ thống quản lý khách ra vào CheckID FacialSense dành cho trường học là một bước đột phá cho các cơ sở giáo dục, mang đến một hệ thống dễ sử dụng và được tích hợp công nghệ sinh trắc học, giúp thay đổi cách thức tiếp đón khách. Dù là đặt lịch thăm quan cho học viên tương lai và gia đình hay tiếp đón khách đến tổ chức hội thảo giáo dục cho người học – hệ thống quản lý khách ra vào cho trường học của chúng tôi chính là giải pháp hoàn hảo.",
      classdefine: "Lớp học: Xác định lịch giảng dạy",
      classdefinedes:
        "Nhà trường có thể xác định và thiết lập thời gian giảng dạy của giảng viên/giáo viên và xây dựng lịch học dựa trên sự sắp xếp đó.",
      classselect: "Người học: Chọn thời gian học",
      classselectdes:
        "Người học có thể lựa chọn khung giờ học phù hợp với lịch trình của mình.",
      student: "Người học: Tham gia lớp học",
      studentdes:
        "Tại địa điểm lớp học, người học chỉ cần xuất trình thẻ lớp cho hệ thống CheckID FacialSense, việc điểm danh sẽ được ghi nhận và quyền ra vào sẽ được cấp.",
      afterclass: "Sau giờ học",
      afterclassdes:
        "Tính năng thông báo sau buổi học có thể được sử dụng để gửi ghi chú bài học/tài liệu điện tử cho học sinh qua e-mail.",
      quicklydes:
        "Cung cấp các hướng dẫn từng bước để bạn có thể bắt đầu thiết lập hệ thống quản lý khách ra vào của CheckID FacialSense cho trường học của mình.",
      if: "Nếu bạn không chắc chắn về bất kỳ điều gì được đề cập trong các hướng dẫn bắt đầu nhanh chóng thì đừng ngần ngại ",
      contact: " liên hệ với chúng tôi",
      anda: " và một thành viên của đội ngũ của chúng tôi sẽ phản hồi lại cho bạn.",
      keyfeatures: "Tính năng chính",
      ofour: " của hệ thống quản lý khách ra vào cho trường học",
      keyfeaturesdes:
        "Chúng tôi mong muốn mang đến một hệ thống được tích hợp đầy đủ các khả năng vượt trội. Đội ngũ chuyên gia giàu kinh nghiệm đã tạo ra hệ thống quản lý khách ra vào trường học mang tính đột phá, phù hợp cho các cơ sở giáo dục ở mọi cấp độ. Mục tiêu của chúng tôi là giảm bớt sự phức tạp trong việc tiếp đón khách và gánh nặng cho nhân viên, thay vào đó mang lại trải nghiệm tiện lợi và an toàn cho tất cả khách đến trường của bạn. Hệ thống quản lý khách ra vào cho trường học có nhiều tính năng nổi bật, bao gồm:",
      online: "Đặt lịch hẹn trực tuyến",
      onlinedes:
        "Cho phép khách lên kế hoạch thăm viếng trước và vào trường một cách dễ dàng, tiện lợi.",
      secure: "Xác nhận ra vào an toàn",
      securedes:
        "Công nghệ nhận diện khách bằng Mã vạch (Barcode), RFID, Khuôn mặt, Vân tay và Mống mắt mang đến khả năng truy cập nhanh chóng, hiệu quả và an toàn cho các cuộc hẹn và tương tác của khách.",
      safe: "An toàn và vệ sinh",
      safedes:
        "Công nghệ nhận dạng không tiếp xúc bằng mã vạch, RFID, khuôn mặt và mống mắt đảm bảo việc nhận dạng khách không tiếp xúc.",
      auto: "Kiểm soát ra vào tự động",
      autodes:
        "Cổng kiểm soát khách được quản lý bằng thiết bị điểm danh, đảm bảo việc cấp quyền ra vào chính xác.",
      real: "Phân tích khách ra vào theo thời gian thực",
      realdes:
        "Thiết bị điểm danh ghi nhận các lần ra vào thành công và bị từ chối trong hệ thống.",
      elec: "Thẻ điện tử",
      elecdes:
        "Tự động phát hành hoặc cấp thẻ điện tử cụ thể như mã vạch, RFID, và biển số xe được phép sử dụng như là thẻ khách.",
      bio: "Nhận dạng khách bằng sinh trắc học",
      biodes:
        "Hệ thống kiểm soát và quản lý ra vào sử dụng công nghệ nhận dạng sinh học đa dạng.",
      cuztom: "Ghi chú thăm có thể tùy chỉnh",
      cuztomdes:
        "Ghi chú thăm tùy chỉnh với các biểu mẫu và tệp đính kèm có thể được sử dụng để tạo ra các nhật ký chi tiết của khách thăm.",
      data: "Quyền riêng tư dữ liệu",
      datades:
        "Các hoạt động của khách thăm được thực hiện bởi nhân viên được ủy quyền, vì vậy mọi thông tin liên quan được bảo vệ khỏi việc truy cập trái phép.",
      transfrom: "Thay đổi",
      howyou:
        " cách bạn quản lý khách ra vào bằng Hệ thống CheckID FacialSense cho trường học",
      transfromdes:
        "Hệ thống của chúng tôi được thiết kế cẩn thận để không chỉ phù hợp mà còn trở thành giải pháp quản lý khách ra vào lý tưởng cho cơ sở của bạn. Chúng tôi hiểu rằng các trường học trên thế giới có sự khác biệt đáng kể về cơ sở hạ tầng và hệ thống quản trị. Chính vì vậy, hệ thống CheckID FacialSense đã được phát triển tinh vi để có thể dễ dàng tích hợp vào môi trường của bạn.",
      choosing:
        "Khi lựa chọn hệ thống quản lý khách ra vào của chúng tôi cho trường học, bạn sẽ nhận được:",
      glowing: "Tạo ấn tượng đầu tiên tuyệt vời với khách mới đến.",
      equipped: "Trang bị công nghệ hiện đại và tiên tiến nhất.",
      safetransfrom:
        "Môi trường an toàn và bảo mật được kích hoạt thông qua chức năng sinh trắc học",
      encrypted:
        "Cơ sở dữ liệu mã hóa để bảo vệ dữ liệu của khách thăm của bạn",
      save: "Tiết kiệm đáng kể thời gian và công sức hành chính, để tập trung cho công việc khác trong trường.",
      quick:
        "Cách nhanh chóng và dễ dàng để xem phân tích vào bất kỳ thời điểm nào trong ngày",
      remote:
        "Truy cập từ xa để đặt lịch hẹn và check-in ngay cả khi không có mặt tại trường.",
      getstart: "Bắt đầu ngay hôm nay",
      wehope:
        "Chúng tôi hy vọng sẽ nhận được phản hồi từ bạn để cùng hỗ trợ chuyển đổi cách trường học của bạn quản lý khách ra vào.",
    },
  },
  pricing: {
    header: "Giá cả",
    employee: "Nhân viên",
    headernone: "Chấm công bằng khuôn mặt CheckID FacialSense",
    cloud: "Đám mây",
    onpremises: "Tại chỗ",
    price: "Giới hạn trong 3 tháng",
    price1: "30 ngày đầu miễn phí",
    price2: "Giá mỗi người dùng 0.87$",
    price3: "30 ngày đầu miễn phí",
    freePLan: "Gói miễn phí",
    free1: "Tiêu chuẩn",
    free2: "Gói tùy chỉnh",
    free3: "Cao cấp",
    month: "/ tháng",
    users: "Người dùng",
    employee1: "tối đa 5 nhân viên",
    employee2: "$ 1,50 mỗi nhân viên",
    employee3: "$ 3,00 mỗi nhân viên",
    mostporpular: "Phổ biến nhất",
    getstart: "Dùng thử miễn phí",
    prices: "Giá chưa bao gồm thuế và phí nhập khẩu địa phương",
    freeclient: "Ứng dụng khách miễn phí",
    foremploy: "cho nhân viên/người dùng (Windows, Android và iOS).",
    custom: "Giải pháp tùy chỉnh",
    make: "Hãy để lại lời nhắn, chúng tôi sẽ phản hồi sớm nhất.",
    licensefor: "1 giấy phép cho 1 thiết bị - 95$",
    license: "Giấy phép",
    one: "/ mua một lần",
    these: "Các giấy phép này có thể sử dụng với các ứng dụng sau:",
    checkid:
      "Máy chủ CheckID FacialSense tại chỗ (hỗ trợ tối đa 100 người dùng)",
    checkidstandrad: "Ứng dụng khách CheckID FacialSense Tiêu chuẩn",
    addtocart: "Thêm vào giỏ hàng",
    formore: "Với hơn 100 người dùng hoặc hơn 10 thiết bị, vui lòng ",
    contactus: "liên hệ với chúng tôi",
    solutions: "Liên hệ để có giải pháp tùy chỉnh phù hợp với bạn!",
    solutions1: "Công ty có hơn 500 nhân viên?",
    solutions2: "Cần giấy phép cho hơn 100 người dùng?",
    solutions3: "Cần giấy phép cho hơn 10 thiết bị?",
    solutions4: "Chúng tôi sẽ tùy chỉnh giải pháp phù hợp với nhu cầu của bạn.",
    customus: "Liên hệ với chúng tôi",
    vissit: "Quản lý khách thăm",
    appoint: "Giá mỗi cuộc hẹn miễn phí",
    appoint1: "Giá mỗi cuộc hẹn 0.03$",
    appoint2: "Giá mỗi cuộc hẹn 0.02$",
    appoint3: "Giá mỗi cuộc hẹn 0.02$",
    dayaponit: "Cuộc hẹn/ngày",
    preces: "Giá chưa bao gồm thuế và phí nhập khẩu địa phương",
    server: "Giấy phép máy chủ",
    unlitmit:
      "Máy chủ quản lý khách thăm CheckID FacialSense tại chỗ (cuộc hẹn không giới hạn)",
    client: "Ứng dụng khách CheckID FacialSense Visitor",
    ser: "Máy chủ quản lý khách thăm CheckID FacialSense",
    freemon: "Miễn phí",
    customplan1: "Thường dành cho công ty có trên 500 nhân viên.",
    customplan2: "Hãy liên hệ để chúng tôi xây dựng gói phù hợp cho bạn!",
    sign: "Đăng ký ngay!",
    contact: "Liên hệ chúng tôi",
    premises: "Có sẵn tại chỗ",
    fearures: "Tính năng sẽ được tùy chỉnh theo nhu cầu cá nhân của bạn.",
    note: "Lưu ý",
    freePlan: "Người dùng gói Miễn phí có cơ hội nâng cấp lên",
    freeForLife: "Miễn phí trọn đời",
    byShareTheirSystemExperience:
      "bằng cách chia sẻ trải nghiệm sử dụng qua bảng điều khiển hệ thống.",
    face: "Nhận diện khuôn mặt",
    gpsTracking: "Theo dõi GPS",
    faceMaskDetection: "Phát hiện đeo khẩu trang",
    timesheetAndReport: "Bảng chấm công và báo cáo",
    personalDevicePerEmployee: "1 thiết bị cá nhân cho mỗi nhân viên",
    devidePerEmployeeGroup: "1 thiết bị cho mỗi nhóm nhân viên",
    workShedule: "Lịch làm việc",
    videoTracking: "Theo dõi khách ra vào, tối đa 100 lượt",
    everythingInPlanFree:
      "Bao gồm tất cả tính năng của gói Miễn phí, cộng thêm",
    faceAndFinger: "Nhận dạng khuôn mặt và vân tay",
    rfidBarcode: "RFID, Mã vạch",
    ipCamera: "Camera IP",
    breakHours: "Giờ nghỉ",
    locationRestriction: "Giới hạn vị trí",
    registrationInformationKiosk: "Kiosk đăng ký/thông tin",
    accessControl: "Kiểm soát truy cập",
    reportsCustomization: "Tùy chỉnh báo cáo",
    ultimatePersonalDevices: "Thiết bị cá nhân không giới hạn",
    unlimitedDevicePergroup: "Thiết bị không giới hạn mỗi nhóm",
    customReportCalculation: "Tính toán báo cáo tùy chỉnh",
    importExportData: "Nhập/Xuất dữ liệu",
    faceFigerprintIris: "Nhận dạng khuôn mặt, vân tay, mống mắt",
    safetyHatDetection: "Phát hiện mũ bảo hộ (PPE)",
    rfidBarCodeLicensePlate: "RFID, mã vạch, biển số xe",
    visitorQueue: "Hàng chờ khách ra vào",
    visitorNote: "Ghi chú khách ra vào",
    upTo3000Visits: "Tối đa 3000 lượt khách",
    badgeReceiptPrinting: "In thẻ/in biên lai",
    notifications: "Thông báo",
    customFeatureExtensions: "Mở rộng tính năng tùy chỉnh",
    biometicDeuplication: "Lọc trùng sinh trắc học và đăng ký lại",
    checkidFacialSenseAdminAppIsForEmployeesAdministrationAndAttendanceManagementAvailableForWindowsAndAndroidNoteThatAPaidLicenseIsRequiredToUseIt:
      "Ứng dụng CheckID FacialSense Admin dùng để quản lý nhân sự và chấm công, có sẵn cho hệ điều hành Windows và Android. Lưu ý rằng cần giấy phép trả phí để sử dụng.",
    checkidFacialSenseAppIsAFreeOnlineToolForPersonalAndGroupAttendanceTrackingIsAvailableForWindowsAndroidIOSOperatingSystems:
      "Ứng dụng CheckID FacialSense là công cụ miễn phí để theo dõi chấm công cá nhân và nhóm. Có sẵn cho Windows, Android và iOS.",
    pricesDoNotIncludeLocalImportDutiesOrTaxes:
      "Giá chưa bao gồm thuế và phí nhập khẩu địa phương.",
    adminApplication: "Ứng dụng quản trị",
    singleDeviceInstallation: "Cài đặt trên một thiết bị",
    requestALicense: "Yêu cầu giấy phép",
    theCheckidFacialSenseAdminAppSimplifiesEmployee:
      "Ứng dụng CheckID FacialSense Admin giúp đơn giản hóa việc đăng ký nhân viên và theo dõi chấm công, biến điện thoại hoặc máy tính bảng của bạn thành kiosk chấm công. Hỗ trợ làm việc online/offline, đồng bộ dữ liệu khi có kết nối internet. Có thể tạo sự kiện, đăng ký thiết bị và tự động chấm công. Liên hệ để nhận giấy phép.",
    supportFaceFingerprintIris: "Hỗ trợ nhận diện khuôn mặt, vân tay, mống mắt",
    automaticFaceDetectionAndCapture: "Tự động phát hiện và chụp khuôn mặt",
    faceLivenessDetection: "Phát hiện khuôn mặt sống",
    recognizeAllPersonsFromGroupPhoto: "Nhận diện tất cả người trong ảnh nhóm",
    geoFenceTracking: "Theo dõi giới hạn địa lý (geo-fence)",
    gpsLocationLogging: "Ghi lại vị trí GPS",
    offlineAttendanceLoging: "Chấm công ngoại tuyến",
    standlonePperation: "Hoạt động độc lập",
    kioskMode: "Chế độ kiosk (rảnh tay)",
    attendApplication: "Ứng dụng chấm công",
    unlimitedInstallation: "Cài đặt không giới hạn",
    free: "Miễn phí",
    downloadApp: "Tải ứng dụng",
    theCheckidFacialSenseAppIsaFreeOInlineTool:
      "Ứng dụng CheckID FacialSense là công cụ trực tuyến miễn phí để theo dõi chấm công cá nhân và nhóm. Cần kết nối internet để chấm công, đảm bảo đồng bộ dữ liệu thời gian thực và truy cập tức thì trên bảng điều khiển. Ứng dụng không hỗ trợ chụp khuôn mặt tự động và không yêu cầu giấy phép.",
    supportsFace: "Hỗ trợ nhận diện khuôn mặt",
    onlineAttendanceLogging: "Chấm công trực tuyến",
    licenseFor1Divices: "giấy phép cho 1 thiết bị",
    titlepage: "Giá cả | Dịch vụ CheckID FacialSense",
  },
  aboutus: {
    header: "Về Chúng Tôi",
    customsolutions: "Giải pháp tùy chỉnh",
    makesure: "Hãy để lại lời nhắn và chúng tôi sẽ phản hồi bạn trong thời gian sớm nhất.",
    contactus: "Liên hệ chúng tôi",
    overtheyears: "Trong suốt những năm qua, chúng tôi đã phát triển và cải tiến nhiều công nghệ độc quyền được sử dụng tại hơn 140 quốc gia trên toàn thế giới.",
    byfocus: "Bằng cách tập trung vào nghiên cứu và phát triển, Mobile-ID nhanh chóng tận dụng các cơ hội mới đến từ làn sóng công nghệ học sâu (deep learning).",
    established: "Được thành lập vào năm 2016, Mobile-ID là đơn vị tiên phong trong lĩnh vực phát triển hệ thống sinh trắc học tại Việt Nam.",
    itwasfound: "Công ty được thành lập với ý tưởng cốt lõi là sử dụng mạng nơ-ron nhân tạo cho các ứng dụng liên quan đến nhận dạng sinh trắc học, robot và trí tuệ nhân tạo.",
    ourjourney: "Hành trình của chúng tôi bắt đầu với việc phát hành sản phẩm sinh trắc học đầu tiên - hệ thống nhận dạng vân tay phục vụ điều tra tội phạm.",
    checkidfacielsensesystem: "CheckID FacialSense là hệ thống quản lý chấm công thông minh được Mobile-ID phát triển vào năm 2024.",
    baseon: "Dựa trên các thuật toán đạt giải thưởng danh giá, sản phẩm của chúng tôi hỗ trợ chấm công nâng cao thông qua nhận diện khuôn mặt, vân tay và mống mắt.",
    checkidfacielsensebio: "Hệ thống CheckID FacialSense Chấm công và Quản lý khách ra vào cung cấp đầy đủ các tính năng như chấm công không tiếp xúc, hỗ trợ offline, quản lý nhân sự, tạo báo cáo và kiểm soát toàn diện quá trình chấm công.",
    althoughit: "Bên cạnh ứng dụng phổ biến nhất là trong môi trường văn phòng, đặc biệt trong bối cảnh làm việc từ xa đang trở thành xu hướng, CheckID FacialSense còn có thể ứng dụng trong giáo dục, y tế, xây dựng và nông nghiệp.",
    wheatheryou: "Dù bạn đang muốn tìm hiểu về các tính năng chấm công và quản lý khách bằng sinh trắc học CheckID FacialSense, hay muốn sử dụng phần mềm hoặc có bất kỳ câu hỏi nào – chúng tôi luôn sẵn sàng hỗ trợ bạn. Hãy liên hệ với chúng tôi ngay hôm nay.",
    checkidfacialsensebiometric: "Hệ thống Sinh trắc học CheckID FacialSense",
    titlepage: "Về Chúng Tôi | Dịch vụ CheckID FacialSense",
  },
  contactus: {
    header: "Liên hệ với chúng tôi",
    getin: "Kết nối",
    touch: "với chúng tôi",
    name: "Họ và tên",
    email: "Email",
    company: "Công ty",
    phone: "Số điện thoại",
    subject: "Chủ đề",
    message: "Nội dung",
    sendmessage: "Gửi tin nhắn",
    contactinformation: "Thông tin liên hệ",
    location: "Tầng 9, Tòa nhà Thủy Lợi 4, 286-288 Đường Nguyễn Xí, Phường Bình Lợi Trung, TP. Hồ Chí Minh",
    enteryourname: "Nhập tên của bạn",
    enteryouremail: "Nhập email của bạn",
    enteryourcompany: "Nhập tên công ty của bạn",
    enteryourphoneno: "Nhập số điện thoại của bạn",
    enteryoursubject: "Nhập chủ đề",
    enteryourmessage: "Nhập nội dung của bạn",
    emailsuccess: "Gửi email thành công!",
    emailerror: "Gửi email thất bại!",
    sending: "Đang gửi...",
    validname: "Vui lòng nhập họ tên",
    validemail: "Vui lòng nhập email",
    validmessage: "Vui lòng nhập tin nhắn",
    required: "Trường bắt buộc",
    invalidphone: "Số điện thoại không hợp lệ",
    invalidemail: "Email không hợp lệ",
    titlepage: "Liên hệ với chúng tôi | Dịch vụ CheckID FacialSense",
  },
  registerasadistributor: {
    header: "Đăng ký làm nhà phân phối",
    description: "Nếu bạn muốn trở thành nhà phân phối, vui lòng điền vào biểu mẫu dưới đây. Chúng tôi sẽ phản hồi yêu cầu của bạn trong vòng một đến hai ngày làm việc.",
    name: "Họ và tên",
    email: "Email",
    company: "Công ty",
    phone: "Số điện thoại",
    subject: "Chủ đề",
    message: "Tin nhắn",
    sendmessage: "Gửi tin nhắn",
    contactinformation: "Thông tin liên hệ",
    location: "Tầng 9, Tòa nhà Thủy Lợi 4, 286-288 đường Nguyễn Xí, phường Bình Lợi Trung, TP. Hồ Chí Minh",
    enteryourname: "Nhập họ và tên của bạn",
    enteryouremail: "Nhập email của bạn",
    enteryourcompany: "Nhập tên công ty của bạn",
    enteryourphoneno: "Nhập số điện thoại của bạn",
    enteryoursubject: "Nhập chủ đề",
    enteryourmessage: "Nhập tin nhắn của bạn",
    emailsuccess: "Gửi email thành công!",
    emailerror: "Gửi email thất bại!",
    sending: "Đang gửi...",
    validname: "Vui lòng nhập họ tên",
    validemail: "Vui lòng nhập email",
    validmessage: "Vui lòng nhập tin nhắn",
    required: "Trường bắt buộc",
    invalidphone: "Số điện thoại không hợp lệ",
    invalidemail: "Email không hợp lệ",
    titlepage: "Đăng ký làm nhà phân phối | Dịch vụ CheckID FacialSense",
  },
  footer: {
    description:
      "Sản phẩm CheckID FacialSense nổi bật trên thị trường là giải pháp đa sinh trắc học tạo ra các ứng dụng hệ thống chính xác và linh hoạt. Hệ thống của chúng tôi được hỗ trợ bởi các thuật toán hàng đầu trong ngành do Mobile-ID phát triển.",
    contact: {
      us: "Liên hệ",
      address:
        " Tầng 9, Tòa nhà Văn Phòng Thủy Lợi 4, 286-288 Nguyễn Xí, Phường Bình Lợi Trung, TP. Hồ Chí Minh",
      phone: " 1900 6884/n +84 28 3622 2982",
      emailName: "info@mobile-id.vn",
    },
    legal: {
      infomation: "Thông tin pháp lý",
      term: "Điều khoản và điều kiện",
      elements: "Yếu tố",
      data: "Thỏa thuận chuyển dữ liệu",
    },
  },
  backtotop: "Về đầu trang",

  cookies: {
    title: "Trang web này sử dụng cookie",
    description: 'Bằng cách xác nhận "Chấp nhận Tất cả", bạn đồng ý cho phép lưu trữ cookie trên thiết bị của mình nhằm cải thiện khả năng điều hướng trang web, phân tích việc sử dụng trang và hỗ trợ các hoạt động tiếp thị của chúng tôi.',
    preferences: "Tùy chọn cookie",
    rejectAll: "Từ chối Tất cả",
    acceptAll: "Chấp nhận Tất cả",

    preferencesTitle: "Thiết lập cookie tùy chọn",
    strictlyNecessary: "Cookie bắt buộc",
    strictlyNecessaryDesc: "Những cookie này cần thiết để trang web hoạt động đúng cách. Chúng không thu thập dữ liệu cho mục đích quảng cáo và không thể tắt đi, vì điều đó sẽ làm gián đoạn các chức năng cơ bản của trang web.",
    alwaysActive: "Luôn hoạt động",

    functional: "Cookie chức năng / Tùy chọn",
    functionalDesc: "Những cookie này ghi nhớ các lựa chọn và cài đặt của bạn để mang lại trải nghiệm cá nhân hóa hơn, chẳng hạn như ngôn ngữ đã chọn, chế độ sáng/tối, cỡ chữ, khu vực hoặc các tùy chỉnh khác.",

    analytics: "Cookie phân tích / Hiệu suất",
    analyticsDesc: "Những cookie này giúp chúng tôi hiểu cách người dùng tương tác với trang web. Toàn bộ dữ liệu đều được ẩn danh hoàn toàn và chỉ dùng để cải thiện hiệu suất trang web, tốc độ tải trang và chất lượng nội dung – không nhận dạng cá nhân.",

    marketing: "Cookie quảng cáo / Tiếp thị",
    marketingDesc: "Những cookie này cho phép chúng tôi hiển thị quảng cáo phù hợp hơn với sở thích của bạn trên trang web của chúng tôi và các nền tảng khác. Chúng theo dõi hành vi duyệt web một cách ẩn danh và ngăn chặn việc hiển thị cùng một quảng cáo lặp lại nhiều lần.",

    savePreferences: "Lưu thiết lập",
    cancel: "Hủy"
  }
};
